(() => {
    var __webpack_modules__ = {
            2015: (__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {
                "use strict";

                ; // CONCATENATED MODULE: ./src/js/common/menu-mobile.js
                function initMobileMenu() {
                    const menu = document.querySelector('.menu-mobile');

                    if (menu) {
                        const closeBtn = menu.querySelector('.js-menu-close');
                        const title = menu.querySelector('.js-menu-title');
                        const previousBtn = menu.querySelector('.js-menu-previous');
                        const inner = menu.querySelector('.menu-mobile__inner');
                        const lists = {
                            1: [...menu.querySelectorAll('.menu-mobile__list--first')],
                            2: [...menu.querySelectorAll('.menu-mobile__list--second')],
                            3: [...menu.querySelectorAll('.menu-mobile__list--third')]
                        };
                        let activeLevel = '1';

                        const open = () => {
                            menu.classList.add('visible');
                            document.body.style.overflowY = 'hidden';
                        };

                        const close = () => {
                            menu.classList.remove('visible');
                            document.querySelector('.menu-mobile__inner').removeAttribute('data-level');
                            document.body.style.overflowY = 'auto';
                        };

                        menu.addEventListener('click', e => {
                            if (e.target.classList.contains('menu-mobile')) {
                                e.preventDefault();
                                close();
                                let header = document.querySelector('.main-header.main-header--announcement');
                                if(header.classList.contains('is-transparent')) {
                                    setTimeout(() => {
                                        header.classList.remove('main-header--dark','main-header__sticky', 'is-transparent');
                                        header.classList.add('main-header--transparent');
                                    }, 300)
                                    document.querySelector('.js-close-mobile-menu').style.display = "none"
                                    document.querySelector('.open-mobile-menu').style.display = "flex"
                                }
                            }
                        });
                        document.querySelectorAll('.js-open-mobile-menu').forEach(btn => {
                            btn.addEventListener('click', e => {
                                e.preventDefault();
                                let header = document.querySelector('.main-header.main-header--announcement');
                                if(header.classList.contains('main-header--transparent')) {
                                    header.classList.remove('main-header--transparent');
                                    header.classList.add('main-header--dark','main-header__sticky', 'is-transparent');
                                }
                                open();
                                document.querySelector('.open-mobile-menu').style.display = "none"
                                document.querySelector('.js-close-mobile-menu').style.display = "flex"
                            });
                        });
                        document.querySelectorAll('.js-close-mobile-menu').forEach(btn => {
                            btn.addEventListener('click', e => {
                                e.preventDefault();
                                let header = document.querySelector('.main-header.main-header--announcement');
                                if(header.classList.contains('main-header--transparent')) {
                                    header.classList.remove('main-header--transparent');
                                    header.classList.add('main-header--dark','main-header__sticky', 'is-transparent');
                                }
                                close();
                                document.querySelector('.js-close-mobile-menu').style.display = "none"
                                document.querySelector('.open-mobile-menu').style.display = "flex"
                            });
                        });

                        if (closeBtn) {
                            closeBtn.addEventListener('click', e => {
                                e.preventDefault();
                                close();
                            });
                        }

                        const updateActiveLevel = level => {
                            activeLevel = level;
                            inner.dataset.level = activeLevel;
                        };

                        if (previousBtn) {
                            previousBtn.addEventListener('click', () => {
                                if (activeLevel === '1') {
                                    // Close menu
                                    menu.classList.remove('visible');
                                } else {
                                    // Got to previous level
                                    updateActiveLevel(`${activeLevel - 1}`);
                                    title.innerText = lists[activeLevel].find(l => l.classList.contains('visible')).dataset.name || 'Accueil';
                                }
                            });
                        }

                        // const updateMenu = link => {
                        //     updateActiveLevel(link.classList.contains('js-menu-next') ? '2' : '1');
                        //     lists[activeLevel].forEach(list => {
                        //         list.classList.remove('visible');
                        //     });
                        //     const ul = link.closest('li').querySelector('.menu-mobile__list');
                        //     ul.classList.add('visible');
                        //     title.innerText = ul.dataset.name;
                        // };

                        // for (let i = 1; i <= 3; i += 1) {
                        //     lists[i].forEach(list => {
                        //         list.querySelectorAll('.js-menu-next').forEach(link => {
                        //             link.addEventListener('click', e => {
                        //                 if (link.dataset.directLink == "false") {
                        //                     e.preventDefault();
                        //                     updateMenu(link);
                        //                 }
                        //             });
                        //         });
                        //     });
                        // }
                    }
                }; // CONCATENATED MODULE: ./node_modules/@shopify/theme-predictive-search/src/validate.js
                function validateQuery(query) {
                    var error;

                    if (query === null || query === undefined) {
                        error = new TypeError("'query' is missing");
                        error.type = "argument";
                        throw error;
                    }

                    if (typeof query !== "string") {
                        error = new TypeError("'query' is not a string");
                        error.type = "argument";
                        throw error;
                    }
                }

                ; // CONCATENATED MODULE: ./node_modules/@shopify/theme-predictive-search/src/utilities/CustomError.js
                function GenericError() {
                    var error = Error.call(this);

                    error.name = "Server error";
                    error.message = "Something went wrong on the server";
                    error.status = 500;

                    return error;
                }

                function NotFoundError(status) {
                    var error = Error.call(this);

                    error.name = "Not found";
                    error.message = "Not found";
                    error.status = status;

                    return error;
                }

                function ServerError() {
                    var error = Error.call(this);

                    error.name = "Server error";
                    error.message = "Something went wrong on the server";
                    error.status = 500;

                    return error;
                }

                function ContentTypeError(status) {
                    var error = Error.call(this);

                    error.name = "Content-Type error";
                    error.message = "Content-Type was not provided or is of wrong type";
                    error.status = status;

                    return error;
                }

                function JsonParseError(status) {
                    var error = Error.call(this);

                    error.name = "JSON parse error";
                    error.message = "JSON syntax error";
                    error.status = status;

                    return error;
                }

                function ThrottledError(status, name, message, retryAfter) {
                    var error = Error.call(this);

                    error.name = name;
                    error.message = message;
                    error.status = status;
                    error.retryAfter = retryAfter;

                    return error;
                }

                function InvalidParameterError(status, name, message) {
                    var error = Error.call(this);

                    error.name = name;
                    error.message = message;
                    error.status = status;

                    return error;
                }

                function ExpectationFailedError(status, name, message) {
                    var error = Error.call(this);

                    error.name = name;
                    error.message = message;
                    error.status = status;

                    return error;
                }

                ; // CONCATENATED MODULE: ./node_modules/@shopify/theme-predictive-search/src/request.js


                function request(searchPath, configParams, query, onSuccess, onError) {
                    var xhr = new XMLHttpRequest();
                    var route = searchPath + '/suggest.json';

                    xhr.onreadystatechange = function() {
                        if (xhr.readyState === XMLHttpRequest.DONE) {
                            var contentType = xhr.getResponseHeader("Content-Type");

                            if (xhr.status >= 500) {
                                onError(new ServerError());

                                return;
                            }

                            if (xhr.status === 404) {
                                onError(new NotFoundError(xhr.status));

                                return;
                            }

                            if (
                                typeof contentType !== "string" ||
                                contentType.toLowerCase().match("application/json") === null
                            ) {
                                onError(new ContentTypeError(xhr.status));

                                return;
                            }

                            if (xhr.status === 417) {
                                try {
                                    var invalidParameterJson = JSON.parse(xhr.responseText);

                                    onError(
                                        new InvalidParameterError(
                                            xhr.status,
                                            invalidParameterJson.message,
                                            invalidParameterJson.description
                                        )
                                    );
                                } catch (error) {
                                    onError(new JsonParseError(xhr.status));
                                }

                                return;
                            }

                            if (xhr.status === 422) {
                                try {
                                    var expectationFailedJson = JSON.parse(xhr.responseText);

                                    onError(
                                        new ExpectationFailedError(
                                            xhr.status,
                                            expectationFailedJson.message,
                                            expectationFailedJson.description
                                        )
                                    );
                                } catch (error) {
                                    onError(new JsonParseError(xhr.status));
                                }

                                return;
                            }

                            if (xhr.status === 429) {
                                try {
                                    var throttledJson = JSON.parse(xhr.responseText);

                                    onError(
                                        new ThrottledError(
                                            xhr.status,
                                            throttledJson.message,
                                            throttledJson.description,
                                            xhr.getResponseHeader("Retry-After")
                                        )
                                    );
                                } catch (error) {
                                    onError(new JsonParseError(xhr.status));
                                }

                                return;
                            }

                            if (xhr.status === 200) {
                                try {
                                    var res = JSON.parse(xhr.responseText);
                                    res.query = query;
                                    onSuccess(res);
                                } catch (error) {
                                    onError(new JsonParseError(xhr.status));
                                }

                                return;
                            }

                            try {
                                var genericErrorJson = JSON.parse(xhr.responseText);
                                onError(
                                    new GenericError(
                                        xhr.status,
                                        genericErrorJson.message,
                                        genericErrorJson.description
                                    )
                                );
                            } catch (error) {
                                onError(new JsonParseError(xhr.status));
                            }

                            return;
                        }
                    };

                    xhr.open(
                        "get",
                        route + "?q=" + encodeURIComponent(query) + "&" + configParams
                    );

                    xhr.setRequestHeader("Content-Type", "application/json");

                    xhr.send();
                }; // CONCATENATED MODULE: ./node_modules/@shopify/theme-predictive-search/src/utilities/debounce.js
                function debounce(func, wait) {
                    var timeout = null;
                    return function() {
                        var context = this;
                        var args = arguments;
                        clearTimeout(timeout);
                        timeout = setTimeout(function() {
                            timeout = null;
                            func.apply(context, args);
                        }, wait || 0);
                    };
                }

                ; // CONCATENATED MODULE: ./node_modules/@shopify/theme-predictive-search/src/utilities/Dispatcher.js
                function Dispatcher() {
                    this.events = {};
                }

                Dispatcher.prototype.on = function(eventName, callback) {
                    var event = this.events[eventName];
                    if (!event) {
                        event = new DispatcherEvent(eventName);
                        this.events[eventName] = event;
                    }
                    event.registerCallback(callback);
                };

                Dispatcher.prototype.off = function(eventName, callback) {
                    var event = this.events[eventName];
                    if (event && event.callbacks.indexOf(callback) > -1) {
                        event.unregisterCallback(callback);
                        if (event.callbacks.length === 0) {
                            delete this.events[eventName];
                        }
                    }
                };

                Dispatcher.prototype.dispatch = function(eventName, payload) {
                    var event = this.events[eventName];
                    if (event) {
                        event.fire(payload);
                    }
                };

                function DispatcherEvent(eventName) {
                    this.eventName = eventName;
                    this.callbacks = [];
                }

                DispatcherEvent.prototype.registerCallback = function(callback) {
                    this.callbacks.push(callback);
                };

                DispatcherEvent.prototype.unregisterCallback = function(callback) {
                    var index = this.callbacks.indexOf(callback);
                    if (index > -1) {
                        this.callbacks.splice(index, 1);
                    }
                };

                DispatcherEvent.prototype.fire = function(payload) {
                    var callbacks = this.callbacks.slice(0);
                    callbacks.forEach(function(callback) {
                        callback(payload);
                    });
                };

                ; // CONCATENATED MODULE: ./node_modules/@shopify/theme-predictive-search/src/utilities/Cache.js
                function Cache(config) {
                    this._store = {};
                    this._keys = [];
                    if (config && config.bucketSize) {
                        this.bucketSize = config.bucketSize;
                    } else {
                        this.bucketSize = 20;
                    }
                }

                Cache.prototype.set = function(key, value) {
                    if (this.count() >= this.bucketSize) {
                        var deleteKey = this._keys.splice(0, 1);
                        this.delete(deleteKey);
                    }

                    this._keys.push(key);
                    this._store[key] = value;

                    return this._store;
                };

                Cache.prototype.get = function(key) {
                    return this._store[key];
                };

                Cache.prototype.has = function(key) {
                    return Boolean(this._store[key]);
                };

                Cache.prototype.count = function() {
                    return Object.keys(this._store).length;
                };

                Cache.prototype.delete = function(key) {
                    var exists = Boolean(this._store[key]);
                    delete this._store[key];
                    return exists && !this._store[key];
                };

                ; // CONCATENATED MODULE: ./node_modules/@shopify/theme-predictive-search/src/utilities/objectToQueryParams.js
                function objectToQueryParams(obj, parentKey) {
                    var output = "";
                    parentKey = parentKey || null;

                    Object.keys(obj).forEach(function(key) {
                        var outputKey = key + "=";
                        if (parentKey) {
                            outputKey = parentKey + "[" + key + "]";
                        }

                        switch (trueTypeOf(obj[key])) {
                            case "object":
                                output += objectToQueryParams(obj[key], parentKey ? outputKey : key);
                                break;
                            case "array":
                                output += outputKey + "=" + obj[key].join(",") + "&";
                                break;
                            default:
                                if (parentKey) {
                                    outputKey += "=";
                                }
                                output += outputKey + encodeURIComponent(obj[key]) + "&";
                                break;
                        }
                    });

                    return output;
                }

                function trueTypeOf(obj) {
                    return Object.prototype.toString
                        .call(obj)
                        .slice(8, -1)
                        .toLowerCase();
                }; // CONCATENATED MODULE: ./node_modules/@shopify/theme-predictive-search/src/theme-predictive-search.js




                var DEBOUNCE_RATE = 10;
                var requestDebounced = debounce(request, DEBOUNCE_RATE);

                function PredictiveSearch(config) {
                    if (!config) {
                        throw new TypeError("No config object was specified");
                    }

                    var configParameters = config;

                    this._retryAfter = null;
                    this._currentQuery = null;

                    this.dispatcher = new Dispatcher();
                    this.cache = new Cache({
                        bucketSize: 40
                    });

                    this.searchPath = configParameters.search_path || "/search";

                    if (configParameters.search_path) {
                        delete configParameters['search_path'];
                    }

                    this.configParams = objectToQueryParams(configParameters);
                }

                PredictiveSearch.SEARCH_PATH = "/search";

                PredictiveSearch.TYPES = {
                    PRODUCT: "product",
                    PAGE: "page",
                    ARTICLE: "article",
                    COLLECTION: "collection"
                };

                PredictiveSearch.FIELDS = {
                    AUTHOR: "author",
                    BODY: "body",
                    PRODUCT_TYPE: "product_type",
                    TAG: "tag",
                    TITLE: "title",
                    VARIANTS_BARCODE: "variants.barcode",
                    VARIANTS_SKU: "variants.sku",
                    VARIANTS_TITLE: "variants.title",
                    VENDOR: "vendor"
                };

                PredictiveSearch.UNAVAILABLE_PRODUCTS = {
                    SHOW: "show",
                    HIDE: "hide",
                    LAST: "last"
                };

                PredictiveSearch.prototype.query = function query(query) {
                    try {
                        validateQuery(query);
                    } catch (error) {
                        this.dispatcher.dispatch("error", error);
                        return;
                    }

                    if (query === "") {
                        return this;
                    }

                    this._currentQuery = normalizeQuery(query);
                    var cacheResult = this.cache.get(this._currentQuery);
                    if (cacheResult) {
                        this.dispatcher.dispatch("success", cacheResult);
                        return this;
                    }

                    requestDebounced(
                        this.searchPath,
                        this.configParams,
                        query,
                        function(result) {
                            this.cache.set(normalizeQuery(result.query), result);
                            if (normalizeQuery(result.query) === this._currentQuery) {
                                this._retryAfter = null;
                                this.dispatcher.dispatch("success", result);
                            }
                        }.bind(this),
                        function(error) {
                            if (error.retryAfter) {
                                this._retryAfter = error.retryAfter;
                            }
                            this.dispatcher.dispatch("error", error);
                        }.bind(this)
                    );

                    return this;
                };

                PredictiveSearch.prototype.on = function on(eventName, callback) {
                    this.dispatcher.on(eventName, callback);

                    return this;
                };

                PredictiveSearch.prototype.off = function on(eventName, callback) {
                    this.dispatcher.off(eventName, callback);

                    return this;
                };

                function normalizeQuery(query) {
                    if (typeof query !== "string") {
                        return null;
                    }

                    return query
                        .trim()
                        .replace(" ", "-")
                        .toLowerCase();
                }

                ; // CONCATENATED MODULE: ./src/js/classes/Search.js

                const RESULT_LIMIT = 8;
                const QUERY_TYPES = ["product", "collection"];
                const DEFAULT_SEARCH_TEXT_INPUT = "input[name=q]";
                const SEARCH_METHOD_PREDICTIVE_SEARCH = 'predictiveSearch';
                const SEARCH_METHOD_SEARCH_AJAX_TEMPLATE = 'searchAjaxTemplate';
                class Search {
                    constructor(searchFormElement, resultCallback, searchMethod = SEARCH_METHOD_PREDICTIVE_SEARCH) {
                        this.form = searchFormElement;
                        this.input = searchFormElement.querySelector(DEFAULT_SEARCH_TEXT_INPUT);
                        this.searchMethod = searchMethod;
                        this.resultCallback = resultCallback;
                        this.predictiveSearch = new PredictiveSearch({
                            resources: {
                                type: QUERY_TYPES,
                                limit: RESULT_LIMIT,
                                options: {
                                    unavailable_products: PredictiveSearch.UNAVAILABLE_PRODUCTS.LAST,
                                    fields: ["title"]
                                }
                            }
                        });
                        this.initialize();
                    }

                    initializePredictiveSearch() {
                        this.predictiveSearch = new PredictiveSearch({
                            resources: {
                                type: QUERY_TYPES,
                                limit: RESULT_LIMIT,
                                options: {
                                    unavailable_products: PredictiveSearch.UNAVAILABLE_PRODUCTS.LAST,
                                    fields: ["title"]
                                }
                            }
                        });
                    }

                    onPredictiveSearchSuccess() {
                        if (this.predictiveSearch) {
                            this.predictiveSearch.on("success", suggestions => {
                                if (typeof this.resultCallback === "function") {
                                    this.resultCallback(suggestions);
                                    document.dispatchEvent(new Event('theme:search:queried'));
                                }
                            });
                        } else {
                            throw new Error('Predictive search is null or undefined');
                        }
                    }

                    onPredictiveSearchError() {
                        if (this.predictiveSearch) {
                            this.predictiveSearch.on("error", function(error) {
                                throw new Error('An error occured while search for something...');
                            });
                        } else {
                            throw new Error('Predictive search is null or undefined');
                        }
                    }

                    launchPredictiveSearchQuery(term) {
                        if (this.predictiveSearch) {
                            this.predictiveSearch.query(term);
                        } else {
                            throw new Error('Predictive search is null or undefined');
                        }
                    }

                    onAjaxSearchSuccess(html, term) {
                        if (typeof this.resultCallback === "function") {
                            this.resultCallback(html);

                            if (term !== '') {
                                const searchEndpointCollection = `/search/suggest.json?q=${term}&${this.predictiveSearch.configParams}`;
                                fetch(searchEndpointCollection).then(response => response.json()).then(suggestions => {
                                    const searchDrawerCollection = document.querySelector('.js-search-drawer-collections');
                                    this.onAjaxSearchCollectionsSuccess(suggestions, searchDrawerCollection);
                                });
                            }

                            document.dispatchEvent(new Event('theme:search:queried'));
                        }
                    }

                    onAjaxSearchCollectionsSuccess(suggestions, searchDrawerCollection) {
                        searchDrawerCollection.innerHTML = '';

                        for (const suggestion of suggestions.resources.results.collections) {
                            if (!suggestion.title.includes('[hidden]')) {
                                searchDrawerCollection.innerHTML += `
            <li>
              <a href="${suggestion.url}">${suggestion.title}
                <span class="icon " aria-hidden="true"> 
                  <svg width="34" height="58" viewBox="0 0 34 58">
                    <path d="M33.994316,29.2997 C33.9839273,28.0006215 33.4683766,26.7565788 32.556816,25.83096 L8.556856,1.83096 C6.60662805,-0.127938536 3.43765494,-0.134967549 1.47875626,1.81526026 C-0.48014242,3.76548807 -0.487171665,6.93446118 1.463056,8.89336 L21.931816,29.3622 L1.463056,49.831 C0.201479749,51.0981853 -0.288229459,52.9421558 0.178397094,54.6683055 C0.645023648,56.3944552 1.99709429,57.7405411 3.72529709,58.1995055 C5.4534999,58.6584699 7.29527975,58.1605853 8.556856,56.8934 L32.556816,32.8934 C33.4989575,31.9370299 34.0169779,30.6419968 33.994316,29.2997 L33.994316,29.2997 Z"></path>
                  </svg>
                </span>
              </a>
            </li>
          `;
                            }
                        }
                    }

                    launchAjaxSearch(term) {
                        const termLinted = term.trim();
                        const searchEndpoint = this.form.action + '?type=product&q=' + termLinted + '&view=ajax&options[prefix]=last&options[unavailable_products]=last';
                        fetch(searchEndpoint).then(res => res.text()).then(html => {
                            this.onAjaxSearchSuccess(html, term);
                        });
                    }

                    initialize() {
                        if (this.input === null) {
                            return false;
                        } // if(this.searchMethod === SEARCH_METHOD_PREDICTIVE_SEARCH) {
                        //   this.initializePredictiveSearch(this.resultCallback);
                        // }


                        const that = this;
                        let timeout = null;
                        this.input.addEventListener('keydown', e => {
                            if (e.key !== 'Enter' && e.key !== 13) {
                                if (timeout) {
                                    clearTimeout(timeout);
                                    timeout = null;
                                }

                                timeout = setTimeout(() => {
                                    const term = this.input.value;
                                    const customEvent = new CustomEvent('theme:search:query', {
                                        detail: {
                                            form: that.form,
                                            term: term
                                        }
                                    });
                                    that.form.dispatchEvent(customEvent);

                                    if (term !== '' && term.length > 4) {
                                        if (this.searchMethod === SEARCH_METHOD_PREDICTIVE_SEARCH) {
                                            this.launchPredictiveSearchQuery(term);
                                        } else if (this.searchMethod === SEARCH_METHOD_SEARCH_AJAX_TEMPLATE) {
                                            this.launchAjaxSearch(term);
                                        }
                                    }
                                }, 50);
                            } else if (e.key === 'Enter') {
                                that.form.submit();
                            }
                        });

                        if (this.searchMethod === SEARCH_METHOD_PREDICTIVE_SEARCH) {
                            this.onPredictiveSearchSuccess(this.resultCallback);
                            this.onPredictiveSearchError();
                        }

                        if (document.body.classList.contains('template-search')) {
                            const term = document.querySelector('.page-search form')?.dataset.term;

                            if (term !== '') {
                                const searchEndpointCollection = `/search/suggest.json?q=${term}&${this.predictiveSearch.configParams}`;
                                fetch(searchEndpointCollection).then(response => response.json()).then(suggestions => {
                                    const searchDrawerCollection = document.querySelector('.page-search .search-drawer__collections');
                                    this.onAjaxSearchCollectionsSuccess(suggestions, searchDrawerCollection);
                                });
                            }
                        }

                        document.dispatchEvent(new Event('theme:search:initialized'));
                    }

                }

                ; // CONCATENATED MODULE: ./node_modules/cleave.js/dist/cleave-esm.js
                var commonjsGlobal = typeof window !== 'undefined' ? window : typeof __webpack_require__.g !== 'undefined' ? __webpack_require__.g : typeof self !== 'undefined' ? self : {};

                var NumeralFormatter = function(numeralDecimalMark,
                    numeralIntegerScale,
                    numeralDecimalScale,
                    numeralThousandsGroupStyle,
                    numeralPositiveOnly,
                    stripLeadingZeroes,
                    prefix,
                    signBeforePrefix,
                    tailPrefix,
                    delimiter) {
                    var owner = this;

                    owner.numeralDecimalMark = numeralDecimalMark || '.';
                    owner.numeralIntegerScale = numeralIntegerScale > 0 ? numeralIntegerScale : 0;
                    owner.numeralDecimalScale = numeralDecimalScale >= 0 ? numeralDecimalScale : 2;
                    owner.numeralThousandsGroupStyle = numeralThousandsGroupStyle || NumeralFormatter.groupStyle.thousand;
                    owner.numeralPositiveOnly = !!numeralPositiveOnly;
                    owner.stripLeadingZeroes = stripLeadingZeroes !== false;
                    owner.prefix = (prefix || prefix === '') ? prefix : '';
                    owner.signBeforePrefix = !!signBeforePrefix;
                    owner.tailPrefix = !!tailPrefix;
                    owner.delimiter = (delimiter || delimiter === '') ? delimiter : ',';
                    owner.delimiterRE = delimiter ? new RegExp('\\' + delimiter, 'g') : '';
                };

                NumeralFormatter.groupStyle = {
                    thousand: 'thousand',
                    lakh: 'lakh',
                    wan: 'wan',
                    none: 'none'
                };

                NumeralFormatter.prototype = {
                    getRawValue: function(value) {
                        return value.replace(this.delimiterRE, '').replace(this.numeralDecimalMark, '.');
                    },

                    format: function(value) {
                        var owner = this,
                            parts, partSign, partSignAndPrefix, partInteger, partDecimal = '';

                        // strip alphabet letters
                        value = value.replace(/[A-Za-z]/g, '')
                            // replace the first decimal mark with reserved placeholder
                            .replace(owner.numeralDecimalMark, 'M')

                            // strip non numeric letters except minus and "M"
                            // this is to ensure prefix has been stripped
                            .replace(/[^\dM-]/g, '')

                            // replace the leading minus with reserved placeholder
                            .replace(/^\-/, 'N')

                            // strip the other minus sign (if present)
                            .replace(/\-/g, '')

                            // replace the minus sign (if present)
                            .replace('N', owner.numeralPositiveOnly ? '' : '-')

                            // replace decimal mark
                            .replace('M', owner.numeralDecimalMark);

                        // strip any leading zeros
                        if (owner.stripLeadingZeroes) {
                            value = value.replace(/^(-)?0+(?=\d)/, '$1');
                        }

                        partSign = value.slice(0, 1) === '-' ? '-' : '';
                        if (typeof owner.prefix != 'undefined') {
                            if (owner.signBeforePrefix) {
                                partSignAndPrefix = partSign + owner.prefix;
                            } else {
                                partSignAndPrefix = owner.prefix + partSign;
                            }
                        } else {
                            partSignAndPrefix = partSign;
                        }

                        partInteger = value;

                        if (value.indexOf(owner.numeralDecimalMark) >= 0) {
                            parts = value.split(owner.numeralDecimalMark);
                            partInteger = parts[0];
                            partDecimal = owner.numeralDecimalMark + parts[1].slice(0, owner.numeralDecimalScale);
                        }

                        if (partSign === '-') {
                            partInteger = partInteger.slice(1);
                        }

                        if (owner.numeralIntegerScale > 0) {
                            partInteger = partInteger.slice(0, owner.numeralIntegerScale);
                        }

                        switch (owner.numeralThousandsGroupStyle) {
                            case NumeralFormatter.groupStyle.lakh:
                                partInteger = partInteger.replace(/(\d)(?=(\d\d)+\d$)/g, '$1' + owner.delimiter);

                                break;

                            case NumeralFormatter.groupStyle.wan:
                                partInteger = partInteger.replace(/(\d)(?=(\d{4})+$)/g, '$1' + owner.delimiter);

                                break;

                            case NumeralFormatter.groupStyle.thousand:
                                partInteger = partInteger.replace(/(\d)(?=(\d{3})+$)/g, '$1' + owner.delimiter);

                                break;
                        }

                        if (owner.tailPrefix) {
                            return partSign + partInteger.toString() + (owner.numeralDecimalScale > 0 ? partDecimal.toString() : '') + owner.prefix;
                        }

                        return partSignAndPrefix + partInteger.toString() + (owner.numeralDecimalScale > 0 ? partDecimal.toString() : '');
                    }
                };

                var NumeralFormatter_1 = NumeralFormatter;

                var DateFormatter = function(datePattern, dateMin, dateMax) {
                    var owner = this;

                    owner.date = [];
                    owner.blocks = [];
                    owner.datePattern = datePattern;
                    owner.dateMin = dateMin
                        .split('-')
                        .reverse()
                        .map(function(x) {
                            return parseInt(x, 10);
                        });
                    if (owner.dateMin.length === 2) owner.dateMin.unshift(0);

                    owner.dateMax = dateMax
                        .split('-')
                        .reverse()
                        .map(function(x) {
                            return parseInt(x, 10);
                        });
                    if (owner.dateMax.length === 2) owner.dateMax.unshift(0);

                    owner.initBlocks();
                };

                DateFormatter.prototype = {
                    initBlocks: function() {
                        var owner = this;
                        owner.datePattern.forEach(function(value) {
                            if (value === 'Y') {
                                owner.blocks.push(4);
                            } else {
                                owner.blocks.push(2);
                            }
                        });
                    },

                    getISOFormatDate: function() {
                        var owner = this,
                            date = owner.date;

                        return date[2] ? (
                            date[2] + '-' + owner.addLeadingZero(date[1]) + '-' + owner.addLeadingZero(date[0])
                        ) : '';
                    },

                    getBlocks: function() {
                        return this.blocks;
                    },

                    getValidatedDate: function(value) {
                        var owner = this,
                            result = '';

                        value = value.replace(/[^\d]/g, '');

                        owner.blocks.forEach(function(length, index) {
                            if (value.length > 0) {
                                var sub = value.slice(0, length),
                                    sub0 = sub.slice(0, 1),
                                    rest = value.slice(length);

                                switch (owner.datePattern[index]) {
                                    case 'd':
                                        if (sub === '00') {
                                            sub = '01';
                                        } else if (parseInt(sub0, 10) > 3) {
                                            sub = '0' + sub0;
                                        } else if (parseInt(sub, 10) > 31) {
                                            sub = '31';
                                        }

                                        break;

                                    case 'm':
                                        if (sub === '00') {
                                            sub = '01';
                                        } else if (parseInt(sub0, 10) > 1) {
                                            sub = '0' + sub0;
                                        } else if (parseInt(sub, 10) > 12) {
                                            sub = '12';
                                        }

                                        break;
                                }

                                result += sub;

                                // update remaining string
                                value = rest;
                            }
                        });

                        return this.getFixedDateString(result);
                    },

                    getFixedDateString: function(value) {
                        var owner = this,
                            datePattern = owner.datePattern,
                            date = [],
                            dayIndex = 0,
                            monthIndex = 0,
                            yearIndex = 0,
                            dayStartIndex = 0,
                            monthStartIndex = 0,
                            yearStartIndex = 0,
                            day, month, year, fullYearDone = false;

                        // mm-dd || dd-mm
                        if (value.length === 4 && datePattern[0].toLowerCase() !== 'y' && datePattern[1].toLowerCase() !== 'y') {
                            dayStartIndex = datePattern[0] === 'd' ? 0 : 2;
                            monthStartIndex = 2 - dayStartIndex;
                            day = parseInt(value.slice(dayStartIndex, dayStartIndex + 2), 10);
                            month = parseInt(value.slice(monthStartIndex, monthStartIndex + 2), 10);

                            date = this.getFixedDate(day, month, 0);
                        }

                        // yyyy-mm-dd || yyyy-dd-mm || mm-dd-yyyy || dd-mm-yyyy || dd-yyyy-mm || mm-yyyy-dd
                        if (value.length === 8) {
                            datePattern.forEach(function(type, index) {
                                switch (type) {
                                    case 'd':
                                        dayIndex = index;
                                        break;
                                    case 'm':
                                        monthIndex = index;
                                        break;
                                    default:
                                        yearIndex = index;
                                        break;
                                }
                            });

                            yearStartIndex = yearIndex * 2;
                            dayStartIndex = (dayIndex <= yearIndex) ? dayIndex * 2 : (dayIndex * 2 + 2);
                            monthStartIndex = (monthIndex <= yearIndex) ? monthIndex * 2 : (monthIndex * 2 + 2);

                            day = parseInt(value.slice(dayStartIndex, dayStartIndex + 2), 10);
                            month = parseInt(value.slice(monthStartIndex, monthStartIndex + 2), 10);
                            year = parseInt(value.slice(yearStartIndex, yearStartIndex + 4), 10);

                            fullYearDone = value.slice(yearStartIndex, yearStartIndex + 4).length === 4;

                            date = this.getFixedDate(day, month, year);
                        }

                        // mm-yy || yy-mm
                        if (value.length === 4 && (datePattern[0] === 'y' || datePattern[1] === 'y')) {
                            monthStartIndex = datePattern[0] === 'm' ? 0 : 2;
                            yearStartIndex = 2 - monthStartIndex;
                            month = parseInt(value.slice(monthStartIndex, monthStartIndex + 2), 10);
                            year = parseInt(value.slice(yearStartIndex, yearStartIndex + 2), 10);

                            fullYearDone = value.slice(yearStartIndex, yearStartIndex + 2).length === 2;

                            date = [0, month, year];
                        }

                        // mm-yyyy || yyyy-mm
                        if (value.length === 6 && (datePattern[0] === 'Y' || datePattern[1] === 'Y')) {
                            monthStartIndex = datePattern[0] === 'm' ? 0 : 4;
                            yearStartIndex = 2 - 0.5 * monthStartIndex;
                            month = parseInt(value.slice(monthStartIndex, monthStartIndex + 2), 10);
                            year = parseInt(value.slice(yearStartIndex, yearStartIndex + 4), 10);

                            fullYearDone = value.slice(yearStartIndex, yearStartIndex + 4).length === 4;

                            date = [0, month, year];
                        }

                        date = owner.getRangeFixedDate(date);
                        owner.date = date;

                        var result = date.length === 0 ? value : datePattern.reduce(function(previous, current) {
                            switch (current) {
                                case 'd':
                                    return previous + (date[0] === 0 ? '' : owner.addLeadingZero(date[0]));
                                case 'm':
                                    return previous + (date[1] === 0 ? '' : owner.addLeadingZero(date[1]));
                                case 'y':
                                    return previous + (fullYearDone ? owner.addLeadingZeroForYear(date[2], false) : '');
                                case 'Y':
                                    return previous + (fullYearDone ? owner.addLeadingZeroForYear(date[2], true) : '');
                            }
                        }, '');

                        return result;
                    },

                    getRangeFixedDate: function(date) {
                        var owner = this,
                            datePattern = owner.datePattern,
                            dateMin = owner.dateMin || [],
                            dateMax = owner.dateMax || [];

                        if (!date.length || (dateMin.length < 3 && dateMax.length < 3)) return date;

                        if (
                            datePattern.find(function(x) {
                                return x.toLowerCase() === 'y';
                            }) &&
                            date[2] === 0
                        ) return date;

                        if (dateMax.length && (dateMax[2] < date[2] || (
                                dateMax[2] === date[2] && (dateMax[1] < date[1] || (
                                    dateMax[1] === date[1] && dateMax[0] < date[0]
                                ))
                            ))) return dateMax;

                        if (dateMin.length && (dateMin[2] > date[2] || (
                                dateMin[2] === date[2] && (dateMin[1] > date[1] || (
                                    dateMin[1] === date[1] && dateMin[0] > date[0]
                                ))
                            ))) return dateMin;

                        return date;
                    },

                    getFixedDate: function(day, month, year) {
                        day = Math.min(day, 31);
                        month = Math.min(month, 12);
                        year = parseInt((year || 0), 10);

                        if ((month < 7 && month % 2 === 0) || (month > 8 && month % 2 === 1)) {
                            day = Math.min(day, month === 2 ? (this.isLeapYear(year) ? 29 : 28) : 30);
                        }

                        return [day, month, year];
                    },

                    isLeapYear: function(year) {
                        return ((year % 4 === 0) && (year % 100 !== 0)) || (year % 400 === 0);
                    },

                    addLeadingZero: function(number) {
                        return (number < 10 ? '0' : '') + number;
                    },

                    addLeadingZeroForYear: function(number, fullYearMode) {
                        if (fullYearMode) {
                            return (number < 10 ? '000' : (number < 100 ? '00' : (number < 1000 ? '0' : ''))) + number;
                        }

                        return (number < 10 ? '0' : '') + number;
                    }
                };

                var DateFormatter_1 = DateFormatter;

                var TimeFormatter = function(timePattern, timeFormat) {
                    var owner = this;

                    owner.time = [];
                    owner.blocks = [];
                    owner.timePattern = timePattern;
                    owner.timeFormat = timeFormat;
                    owner.initBlocks();
                };

                TimeFormatter.prototype = {
                    initBlocks: function() {
                        var owner = this;
                        owner.timePattern.forEach(function() {
                            owner.blocks.push(2);
                        });
                    },

                    getISOFormatTime: function() {
                        var owner = this,
                            time = owner.time;

                        return time[2] ? (
                            owner.addLeadingZero(time[0]) + ':' + owner.addLeadingZero(time[1]) + ':' + owner.addLeadingZero(time[2])
                        ) : '';
                    },

                    getBlocks: function() {
                        return this.blocks;
                    },

                    getTimeFormatOptions: function() {
                        var owner = this;
                        if (String(owner.timeFormat) === '12') {
                            return {
                                maxHourFirstDigit: 1,
                                maxHours: 12,
                                maxMinutesFirstDigit: 5,
                                maxMinutes: 60
                            };
                        }

                        return {
                            maxHourFirstDigit: 2,
                            maxHours: 23,
                            maxMinutesFirstDigit: 5,
                            maxMinutes: 60
                        };
                    },

                    getValidatedTime: function(value) {
                        var owner = this,
                            result = '';

                        value = value.replace(/[^\d]/g, '');

                        var timeFormatOptions = owner.getTimeFormatOptions();

                        owner.blocks.forEach(function(length, index) {
                            if (value.length > 0) {
                                var sub = value.slice(0, length),
                                    sub0 = sub.slice(0, 1),
                                    rest = value.slice(length);

                                switch (owner.timePattern[index]) {

                                    case 'h':
                                        if (parseInt(sub0, 10) > timeFormatOptions.maxHourFirstDigit) {
                                            sub = '0' + sub0;
                                        } else if (parseInt(sub, 10) > timeFormatOptions.maxHours) {
                                            sub = timeFormatOptions.maxHours + '';
                                        }

                                        break;

                                    case 'm':
                                    case 's':
                                        if (parseInt(sub0, 10) > timeFormatOptions.maxMinutesFirstDigit) {
                                            sub = '0' + sub0;
                                        } else if (parseInt(sub, 10) > timeFormatOptions.maxMinutes) {
                                            sub = timeFormatOptions.maxMinutes + '';
                                        }
                                        break;
                                }

                                result += sub;

                                // update remaining string
                                value = rest;
                            }
                        });

                        return this.getFixedTimeString(result);
                    },

                    getFixedTimeString: function(value) {
                        var owner = this,
                            timePattern = owner.timePattern,
                            time = [],
                            secondIndex = 0,
                            minuteIndex = 0,
                            hourIndex = 0,
                            secondStartIndex = 0,
                            minuteStartIndex = 0,
                            hourStartIndex = 0,
                            second, minute, hour;

                        if (value.length === 6) {
                            timePattern.forEach(function(type, index) {
                                switch (type) {
                                    case 's':
                                        secondIndex = index * 2;
                                        break;
                                    case 'm':
                                        minuteIndex = index * 2;
                                        break;
                                    case 'h':
                                        hourIndex = index * 2;
                                        break;
                                }
                            });

                            hourStartIndex = hourIndex;
                            minuteStartIndex = minuteIndex;
                            secondStartIndex = secondIndex;

                            second = parseInt(value.slice(secondStartIndex, secondStartIndex + 2), 10);
                            minute = parseInt(value.slice(minuteStartIndex, minuteStartIndex + 2), 10);
                            hour = parseInt(value.slice(hourStartIndex, hourStartIndex + 2), 10);

                            time = this.getFixedTime(hour, minute, second);
                        }

                        if (value.length === 4 && owner.timePattern.indexOf('s') < 0) {
                            timePattern.forEach(function(type, index) {
                                switch (type) {
                                    case 'm':
                                        minuteIndex = index * 2;
                                        break;
                                    case 'h':
                                        hourIndex = index * 2;
                                        break;
                                }
                            });

                            hourStartIndex = hourIndex;
                            minuteStartIndex = minuteIndex;

                            second = 0;
                            minute = parseInt(value.slice(minuteStartIndex, minuteStartIndex + 2), 10);
                            hour = parseInt(value.slice(hourStartIndex, hourStartIndex + 2), 10);

                            time = this.getFixedTime(hour, minute, second);
                        }

                        owner.time = time;

                        return time.length === 0 ? value : timePattern.reduce(function(previous, current) {
                            switch (current) {
                                case 's':
                                    return previous + owner.addLeadingZero(time[2]);
                                case 'm':
                                    return previous + owner.addLeadingZero(time[1]);
                                case 'h':
                                    return previous + owner.addLeadingZero(time[0]);
                            }
                        }, '');
                    },

                    getFixedTime: function(hour, minute, second) {
                        second = Math.min(parseInt(second || 0, 10), 60);
                        minute = Math.min(minute, 60);
                        hour = Math.min(hour, 60);

                        return [hour, minute, second];
                    },

                    addLeadingZero: function(number) {
                        return (number < 10 ? '0' : '') + number;
                    }
                };

                var TimeFormatter_1 = TimeFormatter;

                var PhoneFormatter = function(formatter, delimiter) {
                    var owner = this;

                    owner.delimiter = (delimiter || delimiter === '') ? delimiter : ' ';
                    owner.delimiterRE = delimiter ? new RegExp('\\' + delimiter, 'g') : '';

                    owner.formatter = formatter;
                };

                PhoneFormatter.prototype = {
                    setFormatter: function(formatter) {
                        this.formatter = formatter;
                    },

                    format: function(phoneNumber) {
                        var owner = this;

                        owner.formatter.clear();

                        // only keep number and +
                        phoneNumber = phoneNumber.replace(/[^\d+]/g, '');

                        // strip non-leading +
                        phoneNumber = phoneNumber.replace(/^\+/, 'B').replace(/\+/g, '').replace('B', '+');

                        // strip delimiter
                        phoneNumber = phoneNumber.replace(owner.delimiterRE, '');

                        var result = '',
                            current, validated = false;

                        for (var i = 0, iMax = phoneNumber.length; i < iMax; i++) {
                            current = owner.formatter.inputDigit(phoneNumber.charAt(i));

                            // has ()- or space inside
                            if (/[\s()-]/g.test(current)) {
                                result = current;

                                validated = true;
                            } else {
                                if (!validated) {
                                    result = current;
                                }
                                // else: over length input
                                // it turns to invalid number again
                            }
                        }

                        // strip ()
                        // e.g. US: 7161234567 returns (716) 123-4567
                        result = result.replace(/[()]/g, '');
                        // replace library delimiter with user customized delimiter
                        result = result.replace(/[\s-]/g, owner.delimiter);

                        return result;
                    }
                };

                var PhoneFormatter_1 = PhoneFormatter;

                var CreditCardDetector = {
                    blocks: {
                        uatp: [4, 5, 6],
                        amex: [4, 6, 5],
                        diners: [4, 6, 4],
                        discover: [4, 4, 4, 4],
                        mastercard: [4, 4, 4, 4],
                        dankort: [4, 4, 4, 4],
                        instapayment: [4, 4, 4, 4],
                        jcb15: [4, 6, 5],
                        jcb: [4, 4, 4, 4],
                        maestro: [4, 4, 4, 4],
                        visa: [4, 4, 4, 4],
                        mir: [4, 4, 4, 4],
                        unionPay: [4, 4, 4, 4],
                        general: [4, 4, 4, 4]
                    },

                    re: {
                        // starts with 1; 15 digits, not starts with 1800 (jcb card)
                        uatp: /^(?!1800)1\d{0,14}/,

                        // starts with 34/37; 15 digits
                        amex: /^3[47]\d{0,13}/,

                        // starts with 6011/65/644-649; 16 digits
                        discover: /^(?:6011|65\d{0,2}|64[4-9]\d?)\d{0,12}/,

                        // starts with 300-305/309 or 36/38/39; 14 digits
                        diners: /^3(?:0([0-5]|9)|[689]\d?)\d{0,11}/,

                        // starts with 51-55/2221–2720; 16 digits
                        mastercard: /^(5[1-5]\d{0,2}|22[2-9]\d{0,1}|2[3-7]\d{0,2})\d{0,12}/,

                        // starts with 5019/4175/4571; 16 digits
                        dankort: /^(5019|4175|4571)\d{0,12}/,

                        // starts with 637-639; 16 digits
                        instapayment: /^63[7-9]\d{0,13}/,

                        // starts with 2131/1800; 15 digits
                        jcb15: /^(?:2131|1800)\d{0,11}/,

                        // starts with 2131/1800/35; 16 digits
                        jcb: /^(?:35\d{0,2})\d{0,12}/,

                        // starts with 50/56-58/6304/67; 16 digits
                        maestro: /^(?:5[0678]\d{0,2}|6304|67\d{0,2})\d{0,12}/,

                        // starts with 22; 16 digits
                        mir: /^220[0-4]\d{0,12}/,

                        // starts with 4; 16 digits
                        visa: /^4\d{0,15}/,

                        // starts with 62/81; 16 digits
                        unionPay: /^(62|81)\d{0,14}/
                    },

                    getStrictBlocks: function(block) {
                        var total = block.reduce(function(prev, current) {
                            return prev + current;
                        }, 0);

                        return block.concat(19 - total);
                    },

                    getInfo: function(value, strictMode) {
                        var blocks = CreditCardDetector.blocks,
                            re = CreditCardDetector.re;

                        // Some credit card can have up to 19 digits number.
                        // Set strictMode to true will remove the 16 max-length restrain,
                        // however, I never found any website validate card number like
                        // this, hence probably you don't want to enable this option.
                        strictMode = !!strictMode;

                        for (var key in re) {
                            if (re[key].test(value)) {
                                var matchedBlocks = blocks[key];
                                return {
                                    type: key,
                                    blocks: strictMode ? this.getStrictBlocks(matchedBlocks) : matchedBlocks
                                };
                            }
                        }

                        return {
                            type: 'unknown',
                            blocks: strictMode ? this.getStrictBlocks(blocks.general) : blocks.general
                        };
                    }
                };

                var CreditCardDetector_1 = CreditCardDetector;

                var Util = {
                    noop: function() {},

                    strip: function(value, re) {
                        return value.replace(re, '');
                    },

                    getPostDelimiter: function(value, delimiter, delimiters) {
                        // single delimiter
                        if (delimiters.length === 0) {
                            return value.slice(-delimiter.length) === delimiter ? delimiter : '';
                        }

                        // multiple delimiters
                        var matchedDelimiter = '';
                        delimiters.forEach(function(current) {
                            if (value.slice(-current.length) === current) {
                                matchedDelimiter = current;
                            }
                        });

                        return matchedDelimiter;
                    },

                    getDelimiterREByDelimiter: function(delimiter) {
                        return new RegExp(delimiter.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1'), 'g');
                    },

                    getNextCursorPosition: function(prevPos, oldValue, newValue, delimiter, delimiters) {
                        // If cursor was at the end of value, just place it back.
                        // Because new value could contain additional chars.
                        if (oldValue.length === prevPos) {
                            return newValue.length;
                        }

                        return prevPos + this.getPositionOffset(prevPos, oldValue, newValue, delimiter, delimiters);
                    },

                    getPositionOffset: function(prevPos, oldValue, newValue, delimiter, delimiters) {
                        var oldRawValue, newRawValue, lengthOffset;

                        oldRawValue = this.stripDelimiters(oldValue.slice(0, prevPos), delimiter, delimiters);
                        newRawValue = this.stripDelimiters(newValue.slice(0, prevPos), delimiter, delimiters);
                        lengthOffset = oldRawValue.length - newRawValue.length;

                        return (lengthOffset !== 0) ? (lengthOffset / Math.abs(lengthOffset)) : 0;
                    },

                    stripDelimiters: function(value, delimiter, delimiters) {
                        var owner = this;

                        // single delimiter
                        if (delimiters.length === 0) {
                            var delimiterRE = delimiter ? owner.getDelimiterREByDelimiter(delimiter) : '';

                            return value.replace(delimiterRE, '');
                        }

                        // multiple delimiters
                        delimiters.forEach(function(current) {
                            current.split('').forEach(function(letter) {
                                value = value.replace(owner.getDelimiterREByDelimiter(letter), '');
                            });
                        });

                        return value;
                    },

                    headStr: function(str, length) {
                        return str.slice(0, length);
                    },

                    getMaxLength: function(blocks) {
                        return blocks.reduce(function(previous, current) {
                            return previous + current;
                        }, 0);
                    },

                    // strip prefix
                    // Before type  |   After type    |     Return value
                    // PEFIX-...    |   PEFIX-...     |     ''
                    // PREFIX-123   |   PEFIX-123     |     123
                    // PREFIX-123   |   PREFIX-23     |     23
                    // PREFIX-123   |   PREFIX-1234   |     1234
                    getPrefixStrippedValue: function(value, prefix, prefixLength, prevResult, delimiter, delimiters, noImmediatePrefix, tailPrefix, signBeforePrefix) {
                        // No prefix
                        if (prefixLength === 0) {
                            return value;
                        }

                        // Value is prefix
                        if (value === prefix && value !== '') {
                            return '';
                        }

                        if (signBeforePrefix && (value.slice(0, 1) == '-')) {
                            var prev = (prevResult.slice(0, 1) == '-') ? prevResult.slice(1) : prevResult;
                            return '-' + this.getPrefixStrippedValue(value.slice(1), prefix, prefixLength, prev, delimiter, delimiters, noImmediatePrefix, tailPrefix, signBeforePrefix);
                        }

                        // Pre result prefix string does not match pre-defined prefix
                        if (prevResult.slice(0, prefixLength) !== prefix && !tailPrefix) {
                            // Check if the first time user entered something
                            if (noImmediatePrefix && !prevResult && value) return value;
                            return '';
                        } else if (prevResult.slice(-prefixLength) !== prefix && tailPrefix) {
                            // Check if the first time user entered something
                            if (noImmediatePrefix && !prevResult && value) return value;
                            return '';
                        }

                        var prevValue = this.stripDelimiters(prevResult, delimiter, delimiters);

                        // New value has issue, someone typed in between prefix letters
                        // Revert to pre value
                        if (value.slice(0, prefixLength) !== prefix && !tailPrefix) {
                            return prevValue.slice(prefixLength);
                        } else if (value.slice(-prefixLength) !== prefix && tailPrefix) {
                            return prevValue.slice(0, -prefixLength - 1);
                        }

                        // No issue, strip prefix for new value
                        return tailPrefix ? value.slice(0, -prefixLength) : value.slice(prefixLength);
                    },

                    getFirstDiffIndex: function(prev, current) {
                        var index = 0;

                        while (prev.charAt(index) === current.charAt(index)) {
                            if (prev.charAt(index++) === '') {
                                return -1;
                            }
                        }

                        return index;
                    },

                    getFormattedValue: function(value, blocks, blocksLength, delimiter, delimiters, delimiterLazyShow) {
                        var result = '',
                            multipleDelimiters = delimiters.length > 0,
                            currentDelimiter = '';

                        // no options, normal input
                        if (blocksLength === 0) {
                            return value;
                        }

                        blocks.forEach(function(length, index) {
                            if (value.length > 0) {
                                var sub = value.slice(0, length),
                                    rest = value.slice(length);

                                if (multipleDelimiters) {
                                    currentDelimiter = delimiters[delimiterLazyShow ? (index - 1) : index] || currentDelimiter;
                                } else {
                                    currentDelimiter = delimiter;
                                }

                                if (delimiterLazyShow) {
                                    if (index > 0) {
                                        result += currentDelimiter;
                                    }

                                    result += sub;
                                } else {
                                    result += sub;

                                    if (sub.length === length && index < blocksLength - 1) {
                                        result += currentDelimiter;
                                    }
                                }

                                // update remaining string
                                value = rest;
                            }
                        });

                        return result;
                    },

                    // move cursor to the end
                    // the first time user focuses on an input with prefix
                    fixPrefixCursor: function(el, prefix, delimiter, delimiters) {
                        if (!el) {
                            return;
                        }

                        var val = el.value,
                            appendix = delimiter || (delimiters[0] || ' ');

                        if (!el.setSelectionRange || !prefix || (prefix.length + appendix.length) <= val.length) {
                            return;
                        }

                        var len = val.length * 2;

                        // set timeout to avoid blink
                        setTimeout(function() {
                            el.setSelectionRange(len, len);
                        }, 1);
                    },

                    // Check if input field is fully selected
                    checkFullSelection: function(value) {
                        try {
                            var selection = window.getSelection() || document.getSelection() || {};
                            return selection.toString().length === value.length;
                        } catch (ex) {
                            // Ignore
                        }

                        return false;
                    },

                    setSelection: function(element, position, doc) {
                        if (element !== this.getActiveElement(doc)) {
                            return;
                        }

                        // cursor is already in the end
                        if (element && element.value.length <= position) {
                            return;
                        }

                        if (element.createTextRange) {
                            var range = element.createTextRange();

                            range.move('character', position);
                            range.select();
                        } else {
                            try {
                                element.setSelectionRange(position, position);
                            } catch (e) {
                                // eslint-disable-next-line
                                console.warn('The input element type does not support selection');
                            }
                        }
                    },

                    getActiveElement: function(parent) {
                        var activeElement = parent.activeElement;
                        if (activeElement && activeElement.shadowRoot) {
                            return this.getActiveElement(activeElement.shadowRoot);
                        }
                        return activeElement;
                    },

                    isAndroid: function() {
                        return navigator && /android/i.test(navigator.userAgent);
                    },

                    // On Android chrome, the keyup and keydown events
                    // always return key code 229 as a composition that
                    // buffers the user’s keystrokes
                    // see https://github.com/nosir/cleave.js/issues/147
                    isAndroidBackspaceKeydown: function(lastInputValue, currentInputValue) {
                        if (!this.isAndroid() || !lastInputValue || !currentInputValue) {
                            return false;
                        }

                        return currentInputValue === lastInputValue.slice(0, -1);
                    }
                };

                var Util_1 = Util;

                /**
                 * Props Assignment
                 *
                 * Separate this, so react module can share the usage
                 */
                var DefaultProperties = {
                    // Maybe change to object-assign
                    // for now just keep it as simple
                    assign: function(target, opts) {
                        target = target || {};
                        opts = opts || {};

                        // credit card
                        target.creditCard = !!opts.creditCard;
                        target.creditCardStrictMode = !!opts.creditCardStrictMode;
                        target.creditCardType = '';
                        target.onCreditCardTypeChanged = opts.onCreditCardTypeChanged || (function() {});

                        // phone
                        target.phone = !!opts.phone;
                        target.phoneRegionCode = opts.phoneRegionCode || 'AU';
                        target.phoneFormatter = {};

                        // time
                        target.time = !!opts.time;
                        target.timePattern = opts.timePattern || ['h', 'm', 's'];
                        target.timeFormat = opts.timeFormat || '24';
                        target.timeFormatter = {};

                        // date
                        target.date = !!opts.date;
                        target.datePattern = opts.datePattern || ['d', 'm', 'Y'];
                        target.dateMin = opts.dateMin || '';
                        target.dateMax = opts.dateMax || '';
                        target.dateFormatter = {};

                        // numeral
                        target.numeral = !!opts.numeral;
                        target.numeralIntegerScale = opts.numeralIntegerScale > 0 ? opts.numeralIntegerScale : 0;
                        target.numeralDecimalScale = opts.numeralDecimalScale >= 0 ? opts.numeralDecimalScale : 2;
                        target.numeralDecimalMark = opts.numeralDecimalMark || '.';
                        target.numeralThousandsGroupStyle = opts.numeralThousandsGroupStyle || 'thousand';
                        target.numeralPositiveOnly = !!opts.numeralPositiveOnly;
                        target.stripLeadingZeroes = opts.stripLeadingZeroes !== false;
                        target.signBeforePrefix = !!opts.signBeforePrefix;
                        target.tailPrefix = !!opts.tailPrefix;

                        // others
                        target.swapHiddenInput = !!opts.swapHiddenInput;

                        target.numericOnly = target.creditCard || target.date || !!opts.numericOnly;

                        target.uppercase = !!opts.uppercase;
                        target.lowercase = !!opts.lowercase;

                        target.prefix = (target.creditCard || target.date) ? '' : (opts.prefix || '');
                        target.noImmediatePrefix = !!opts.noImmediatePrefix;
                        target.prefixLength = target.prefix.length;
                        target.rawValueTrimPrefix = !!opts.rawValueTrimPrefix;
                        target.copyDelimiter = !!opts.copyDelimiter;

                        target.initValue = (opts.initValue !== undefined && opts.initValue !== null) ? opts.initValue.toString() : '';

                        target.delimiter =
                            (opts.delimiter || opts.delimiter === '') ? opts.delimiter :
                            (opts.date ? '/' :
                                (opts.time ? ':' :
                                    (opts.numeral ? ',' :
                                        (opts.phone ? ' ' :
                                            ' '))));
                        target.delimiterLength = target.delimiter.length;
                        target.delimiterLazyShow = !!opts.delimiterLazyShow;
                        target.delimiters = opts.delimiters || [];

                        target.blocks = opts.blocks || [];
                        target.blocksLength = target.blocks.length;

                        target.root = (typeof commonjsGlobal === 'object' && commonjsGlobal) ? commonjsGlobal : window;
                        target.document = opts.document || target.root.document;

                        target.maxLength = 0;

                        target.backspace = false;
                        target.result = '';

                        target.onValueChanged = opts.onValueChanged || (function() {});

                        return target;
                    }
                };

                var DefaultProperties_1 = DefaultProperties;

                /**
                 * Construct a new Cleave instance by passing the configuration object
                 *
                 * @param {String | HTMLElement} element
                 * @param {Object} opts
                 */
                var Cleave = function(element, opts) {
                    var owner = this;
                    var hasMultipleElements = false;

                    if (typeof element === 'string') {
                        owner.element = document.querySelector(element);
                        hasMultipleElements = document.querySelectorAll(element).length > 1;
                    } else {
                        if (typeof element.length !== 'undefined' && element.length > 0) {
                            owner.element = element[0];
                            hasMultipleElements = element.length > 1;
                        } else {
                            owner.element = element;
                        }
                    }

                    if (!owner.element) {
                        throw new Error('[cleave.js] Please check the element');
                    }

                    if (hasMultipleElements) {
                        try {
                            // eslint-disable-next-line
                            console.warn('[cleave.js] Multiple input fields matched, cleave.js will only take the first one.');
                        } catch (e) {
                            // Old IE
                        }
                    }

                    opts.initValue = owner.element.value;

                    owner.properties = Cleave.DefaultProperties.assign({}, opts);

                    owner.init();
                };

                Cleave.prototype = {
                    init: function() {
                        var owner = this,
                            pps = owner.properties;

                        // no need to use this lib
                        if (!pps.numeral && !pps.phone && !pps.creditCard && !pps.time && !pps.date && (pps.blocksLength === 0 && !pps.prefix)) {
                            owner.onInput(pps.initValue);

                            return;
                        }

                        pps.maxLength = Cleave.Util.getMaxLength(pps.blocks);

                        owner.isAndroid = Cleave.Util.isAndroid();
                        owner.lastInputValue = '';
                        owner.isBackward = '';

                        owner.onChangeListener = owner.onChange.bind(owner);
                        owner.onKeyDownListener = owner.onKeyDown.bind(owner);
                        owner.onFocusListener = owner.onFocus.bind(owner);
                        owner.onCutListener = owner.onCut.bind(owner);
                        owner.onCopyListener = owner.onCopy.bind(owner);

                        owner.initSwapHiddenInput();

                        owner.element.addEventListener('input', owner.onChangeListener);
                        owner.element.addEventListener('keydown', owner.onKeyDownListener);
                        owner.element.addEventListener('focus', owner.onFocusListener);
                        owner.element.addEventListener('cut', owner.onCutListener);
                        owner.element.addEventListener('copy', owner.onCopyListener);


                        owner.initPhoneFormatter();
                        owner.initDateFormatter();
                        owner.initTimeFormatter();
                        owner.initNumeralFormatter();

                        // avoid touch input field if value is null
                        // otherwise Firefox will add red box-shadow for <input required />
                        if (pps.initValue || (pps.prefix && !pps.noImmediatePrefix)) {
                            owner.onInput(pps.initValue);
                        }
                    },

                    initSwapHiddenInput: function() {
                        var owner = this,
                            pps = owner.properties;
                        if (!pps.swapHiddenInput) return;

                        var inputFormatter = owner.element.cloneNode(true);
                        owner.element.parentNode.insertBefore(inputFormatter, owner.element);

                        owner.elementSwapHidden = owner.element;
                        owner.elementSwapHidden.type = 'hidden';

                        owner.element = inputFormatter;
                        owner.element.id = '';
                    },

                    initNumeralFormatter: function() {
                        var owner = this,
                            pps = owner.properties;

                        if (!pps.numeral) {
                            return;
                        }

                        pps.numeralFormatter = new Cleave.NumeralFormatter(
                            pps.numeralDecimalMark,
                            pps.numeralIntegerScale,
                            pps.numeralDecimalScale,
                            pps.numeralThousandsGroupStyle,
                            pps.numeralPositiveOnly,
                            pps.stripLeadingZeroes,
                            pps.prefix,
                            pps.signBeforePrefix,
                            pps.tailPrefix,
                            pps.delimiter
                        );
                    },

                    initTimeFormatter: function() {
                        var owner = this,
                            pps = owner.properties;

                        if (!pps.time) {
                            return;
                        }

                        pps.timeFormatter = new Cleave.TimeFormatter(pps.timePattern, pps.timeFormat);
                        pps.blocks = pps.timeFormatter.getBlocks();
                        pps.blocksLength = pps.blocks.length;
                        pps.maxLength = Cleave.Util.getMaxLength(pps.blocks);
                    },

                    initDateFormatter: function() {
                        var owner = this,
                            pps = owner.properties;

                        if (!pps.date) {
                            return;
                        }

                        pps.dateFormatter = new Cleave.DateFormatter(pps.datePattern, pps.dateMin, pps.dateMax);
                        pps.blocks = pps.dateFormatter.getBlocks();
                        pps.blocksLength = pps.blocks.length;
                        pps.maxLength = Cleave.Util.getMaxLength(pps.blocks);
                    },

                    initPhoneFormatter: function() {
                        var owner = this,
                            pps = owner.properties;

                        if (!pps.phone) {
                            return;
                        }

                        // Cleave.AsYouTypeFormatter should be provided by
                        // external google closure lib
                        try {
                            pps.phoneFormatter = new Cleave.PhoneFormatter(
                                new pps.root.Cleave.AsYouTypeFormatter(pps.phoneRegionCode),
                                pps.delimiter
                            );
                        } catch (ex) {
                            throw new Error('[cleave.js] Please include phone-type-formatter.{country}.js lib');
                        }
                    },

                    onKeyDown: function(event) {
                        var owner = this,
                            charCode = event.which || event.keyCode;

                        owner.lastInputValue = owner.element.value;
                        owner.isBackward = charCode === 8;
                    },

                    onChange: function(event) {
                        var owner = this,
                            pps = owner.properties,
                            Util = Cleave.Util;

                        owner.isBackward = owner.isBackward || event.inputType === 'deleteContentBackward';

                        var postDelimiter = Util.getPostDelimiter(owner.lastInputValue, pps.delimiter, pps.delimiters);

                        if (owner.isBackward && postDelimiter) {
                            pps.postDelimiterBackspace = postDelimiter;
                        } else {
                            pps.postDelimiterBackspace = false;
                        }

                        this.onInput(this.element.value);
                    },

                    onFocus: function() {
                        var owner = this,
                            pps = owner.properties;
                        owner.lastInputValue = owner.element.value;

                        if (pps.prefix && pps.noImmediatePrefix && !owner.element.value) {
                            this.onInput(pps.prefix);
                        }

                        Cleave.Util.fixPrefixCursor(owner.element, pps.prefix, pps.delimiter, pps.delimiters);
                    },

                    onCut: function(e) {
                        if (!Cleave.Util.checkFullSelection(this.element.value)) return;
                        this.copyClipboardData(e);
                        this.onInput('');
                    },

                    onCopy: function(e) {
                        if (!Cleave.Util.checkFullSelection(this.element.value)) return;
                        this.copyClipboardData(e);
                    },

                    copyClipboardData: function(e) {
                        var owner = this,
                            pps = owner.properties,
                            Util = Cleave.Util,
                            inputValue = owner.element.value,
                            textToCopy = '';

                        if (!pps.copyDelimiter) {
                            textToCopy = Util.stripDelimiters(inputValue, pps.delimiter, pps.delimiters);
                        } else {
                            textToCopy = inputValue;
                        }

                        try {
                            if (e.clipboardData) {
                                e.clipboardData.setData('Text', textToCopy);
                            } else {
                                window.clipboardData.setData('Text', textToCopy);
                            }

                            e.preventDefault();
                        } catch (ex) {
                            //  empty
                        }
                    },

                    onInput: function(value) {
                        var owner = this,
                            pps = owner.properties,
                            Util = Cleave.Util;

                        // case 1: delete one more character "4"
                        // 1234*| -> hit backspace -> 123|
                        // case 2: last character is not delimiter which is:
                        // 12|34* -> hit backspace -> 1|34*
                        // note: no need to apply this for numeral mode
                        var postDelimiterAfter = Util.getPostDelimiter(value, pps.delimiter, pps.delimiters);
                        if (!pps.numeral && pps.postDelimiterBackspace && !postDelimiterAfter) {
                            value = Util.headStr(value, value.length - pps.postDelimiterBackspace.length);
                        }

                        // phone formatter
                        if (pps.phone) {
                            if (pps.prefix && (!pps.noImmediatePrefix || value.length)) {
                                pps.result = pps.prefix + pps.phoneFormatter.format(value).slice(pps.prefix.length);
                            } else {
                                pps.result = pps.phoneFormatter.format(value);
                            }
                            owner.updateValueState();

                            return;
                        }

                        // numeral formatter
                        if (pps.numeral) {
                            // Do not show prefix when noImmediatePrefix is specified
                            // This mostly because we need to show user the native input placeholder
                            if (pps.prefix && pps.noImmediatePrefix && value.length === 0) {
                                pps.result = '';
                            } else {
                                pps.result = pps.numeralFormatter.format(value);
                            }
                            owner.updateValueState();

                            return;
                        }

                        // date
                        if (pps.date) {
                            value = pps.dateFormatter.getValidatedDate(value);
                        }

                        // time
                        if (pps.time) {
                            value = pps.timeFormatter.getValidatedTime(value);
                        }

                        // strip delimiters
                        value = Util.stripDelimiters(value, pps.delimiter, pps.delimiters);

                        // strip prefix
                        value = Util.getPrefixStrippedValue(value, pps.prefix, pps.prefixLength, pps.result, pps.delimiter, pps.delimiters, pps.noImmediatePrefix, pps.tailPrefix, pps.signBeforePrefix);

                        // strip non-numeric characters
                        value = pps.numericOnly ? Util.strip(value, /[^\d]/g) : value;

                        // convert case
                        value = pps.uppercase ? value.toUpperCase() : value;
                        value = pps.lowercase ? value.toLowerCase() : value;

                        // prevent from showing prefix when no immediate option enabled with empty input value
                        if (pps.prefix) {
                            if (pps.tailPrefix) {
                                value = value + pps.prefix;
                            } else {
                                value = pps.prefix + value;
                            }


                            // no blocks specified, no need to do formatting
                            if (pps.blocksLength === 0) {
                                pps.result = value;
                                owner.updateValueState();

                                return;
                            }
                        }

                        // update credit card props
                        if (pps.creditCard) {
                            owner.updateCreditCardPropsByValue(value);
                        }

                        // strip over length characters
                        value = Util.headStr(value, pps.maxLength);

                        // apply blocks
                        pps.result = Util.getFormattedValue(
                            value,
                            pps.blocks, pps.blocksLength,
                            pps.delimiter, pps.delimiters, pps.delimiterLazyShow
                        );

                        owner.updateValueState();
                    },

                    updateCreditCardPropsByValue: function(value) {
                        var owner = this,
                            pps = owner.properties,
                            Util = Cleave.Util,
                            creditCardInfo;

                        // At least one of the first 4 characters has changed
                        if (Util.headStr(pps.result, 4) === Util.headStr(value, 4)) {
                            return;
                        }

                        creditCardInfo = Cleave.CreditCardDetector.getInfo(value, pps.creditCardStrictMode);

                        pps.blocks = creditCardInfo.blocks;
                        pps.blocksLength = pps.blocks.length;
                        pps.maxLength = Util.getMaxLength(pps.blocks);

                        // credit card type changed
                        if (pps.creditCardType !== creditCardInfo.type) {
                            pps.creditCardType = creditCardInfo.type;

                            pps.onCreditCardTypeChanged.call(owner, pps.creditCardType);
                        }
                    },

                    updateValueState: function() {
                        var owner = this,
                            Util = Cleave.Util,
                            pps = owner.properties;

                        if (!owner.element) {
                            return;
                        }

                        var endPos = owner.element.selectionEnd;
                        var oldValue = owner.element.value;
                        var newValue = pps.result;

                        endPos = Util.getNextCursorPosition(endPos, oldValue, newValue, pps.delimiter, pps.delimiters);

                        // fix Android browser type="text" input field
                        // cursor not jumping issue
                        if (owner.isAndroid) {
                            window.setTimeout(function() {
                                owner.element.value = newValue;
                                Util.setSelection(owner.element, endPos, pps.document, false);
                                owner.callOnValueChanged();
                            }, 1);

                            return;
                        }

                        owner.element.value = newValue;
                        if (pps.swapHiddenInput) owner.elementSwapHidden.value = owner.getRawValue();

                        Util.setSelection(owner.element, endPos, pps.document, false);
                        owner.callOnValueChanged();
                    },

                    callOnValueChanged: function() {
                        var owner = this,
                            pps = owner.properties;

                        pps.onValueChanged.call(owner, {
                            target: {
                                name: owner.element.name,
                                value: pps.result,
                                rawValue: owner.getRawValue()
                            }
                        });
                    },

                    setPhoneRegionCode: function(phoneRegionCode) {
                        var owner = this,
                            pps = owner.properties;

                        pps.phoneRegionCode = phoneRegionCode;
                        owner.initPhoneFormatter();
                        owner.onChange();
                    },

                    setRawValue: function(value) {
                        var owner = this,
                            pps = owner.properties;

                        value = value !== undefined && value !== null ? value.toString() : '';

                        if (pps.numeral) {
                            value = value.replace('.', pps.numeralDecimalMark);
                        }

                        pps.postDelimiterBackspace = false;

                        owner.element.value = value;
                        owner.onInput(value);
                    },

                    getRawValue: function() {
                        var owner = this,
                            pps = owner.properties,
                            Util = Cleave.Util,
                            rawValue = owner.element.value;

                        if (pps.rawValueTrimPrefix) {
                            rawValue = Util.getPrefixStrippedValue(rawValue, pps.prefix, pps.prefixLength, pps.result, pps.delimiter, pps.delimiters, pps.noImmediatePrefix, pps.tailPrefix, pps.signBeforePrefix);
                        }

                        if (pps.numeral) {
                            rawValue = pps.numeralFormatter.getRawValue(rawValue);
                        } else {
                            rawValue = Util.stripDelimiters(rawValue, pps.delimiter, pps.delimiters);
                        }

                        return rawValue;
                    },

                    getISOFormatDate: function() {
                        var owner = this,
                            pps = owner.properties;

                        return pps.date ? pps.dateFormatter.getISOFormatDate() : '';
                    },

                    getISOFormatTime: function() {
                        var owner = this,
                            pps = owner.properties;

                        return pps.time ? pps.timeFormatter.getISOFormatTime() : '';
                    },

                    getFormattedValue: function() {
                        return this.element.value;
                    },

                    destroy: function() {
                        var owner = this;

                        owner.element.removeEventListener('input', owner.onChangeListener);
                        owner.element.removeEventListener('keydown', owner.onKeyDownListener);
                        owner.element.removeEventListener('focus', owner.onFocusListener);
                        owner.element.removeEventListener('cut', owner.onCutListener);
                        owner.element.removeEventListener('copy', owner.onCopyListener);
                    },

                    toString: function() {
                        return '[Cleave Object]';
                    }
                };

                Cleave.NumeralFormatter = NumeralFormatter_1;
                Cleave.DateFormatter = DateFormatter_1;
                Cleave.TimeFormatter = TimeFormatter_1;
                Cleave.PhoneFormatter = PhoneFormatter_1;
                Cleave.CreditCardDetector = CreditCardDetector_1;
                Cleave.Util = Util_1;
                Cleave.DefaultProperties = DefaultProperties_1;

                // for angular directive
                ((typeof commonjsGlobal === 'object' && commonjsGlobal) ? commonjsGlobal : window)['Cleave'] = Cleave;

                // CommonJS
                var Cleave_1 = Cleave;

                /* harmony default export */
                const cleave_esm = (Cleave_1);

                // EXTERNAL MODULE: ./node_modules/custom-select/build/index.js
                var build = __webpack_require__(9060);; // CONCATENATED MODULE: ./node_modules/perfect-scrollbar/dist/perfect-scrollbar.esm.js
                /*!
                 * perfect-scrollbar v1.5.3
                 * Copyright 2021 Hyunje Jun, MDBootstrap and Contributors
                 * Licensed under MIT
                 */

                function get(element) {
                    return getComputedStyle(element);
                }

                function set(element, obj) {
                    for (var key in obj) {
                        var val = obj[key];
                        if (typeof val === 'number') {
                            val = val + "px";
                        }
                        element.style[key] = val;
                    }
                    return element;
                }

                function div(className) {
                    var div = document.createElement('div');
                    div.className = className;
                    return div;
                }

                var elMatches =
                    typeof Element !== 'undefined' &&
                    (Element.prototype.matches ||
                        Element.prototype.webkitMatchesSelector ||
                        Element.prototype.mozMatchesSelector ||
                        Element.prototype.msMatchesSelector);

                function matches(element, query) {
                    if (!elMatches) {
                        throw new Error('No element matching method supported');
                    }

                    return elMatches.call(element, query);
                }

                function remove(element) {
                    if (element.remove) {
                        element.remove();
                    } else {
                        if (element.parentNode) {
                            element.parentNode.removeChild(element);
                        }
                    }
                }

                function queryChildren(element, selector) {
                    return Array.prototype.filter.call(element.children, function(child) {
                        return matches(child, selector);
                    });
                }

                var cls = {
                    main: 'ps',
                    rtl: 'ps__rtl',
                    element: {
                        thumb: function(x) {
                            return ("ps__thumb-" + x);
                        },
                        rail: function(x) {
                            return ("ps__rail-" + x);
                        },
                        consuming: 'ps__child--consume',
                    },
                    state: {
                        focus: 'ps--focus',
                        clicking: 'ps--clicking',
                        active: function(x) {
                            return ("ps--active-" + x);
                        },
                        scrolling: function(x) {
                            return ("ps--scrolling-" + x);
                        },
                    },
                };

                /*
                 * Helper methods
                 */
                var scrollingClassTimeout = {
                    x: null,
                    y: null
                };

                function addScrollingClass(i, x) {
                    var classList = i.element.classList;
                    var className = cls.state.scrolling(x);

                    if (classList.contains(className)) {
                        clearTimeout(scrollingClassTimeout[x]);
                    } else {
                        classList.add(className);
                    }
                }

                function removeScrollingClass(i, x) {
                    scrollingClassTimeout[x] = setTimeout(
                        function() {
                            return i.isAlive && i.element.classList.remove(cls.state.scrolling(x));
                        },
                        i.settings.scrollingThreshold
                    );
                }

                function setScrollingClassInstantly(i, x) {
                    addScrollingClass(i, x);
                    removeScrollingClass(i, x);
                }

                var EventElement = function EventElement(element) {
                    this.element = element;
                    this.handlers = {};
                };

                var prototypeAccessors = {
                    isEmpty: {
                        configurable: true
                    }
                };

                EventElement.prototype.bind = function bind(eventName, handler) {
                    if (typeof this.handlers[eventName] === 'undefined') {
                        this.handlers[eventName] = [];
                    }
                    this.handlers[eventName].push(handler);
                    this.element.addEventListener(eventName, handler, false);
                };

                EventElement.prototype.unbind = function unbind(eventName, target) {
                    var this$1 = this;

                    this.handlers[eventName] = this.handlers[eventName].filter(function(handler) {
                        if (target && handler !== target) {
                            return true;
                        }
                        this$1.element.removeEventListener(eventName, handler, false);
                        return false;
                    });
                };

                EventElement.prototype.unbindAll = function unbindAll() {
                    for (var name in this.handlers) {
                        this.unbind(name);
                    }
                };

                prototypeAccessors.isEmpty.get = function() {
                    var this$1 = this;

                    return Object.keys(this.handlers).every(
                        function(key) {
                            return this$1.handlers[key].length === 0;
                        }
                    );
                };

                Object.defineProperties(EventElement.prototype, prototypeAccessors);

                var EventManager = function EventManager() {
                    this.eventElements = [];
                };

                EventManager.prototype.eventElement = function eventElement(element) {
                    var ee = this.eventElements.filter(function(ee) {
                        return ee.element === element;
                    })[0];
                    if (!ee) {
                        ee = new EventElement(element);
                        this.eventElements.push(ee);
                    }
                    return ee;
                };

                EventManager.prototype.bind = function bind(element, eventName, handler) {
                    this.eventElement(element).bind(eventName, handler);
                };

                EventManager.prototype.unbind = function unbind(element, eventName, handler) {
                    var ee = this.eventElement(element);
                    ee.unbind(eventName, handler);

                    if (ee.isEmpty) {
                        // remove
                        this.eventElements.splice(this.eventElements.indexOf(ee), 1);
                    }
                };

                EventManager.prototype.unbindAll = function unbindAll() {
                    this.eventElements.forEach(function(e) {
                        return e.unbindAll();
                    });
                    this.eventElements = [];
                };

                EventManager.prototype.once = function once(element, eventName, handler) {
                    var ee = this.eventElement(element);
                    var onceHandler = function(evt) {
                        ee.unbind(eventName, onceHandler);
                        handler(evt);
                    };
                    ee.bind(eventName, onceHandler);
                };

                function createEvent(name) {
                    if (typeof window.CustomEvent === 'function') {
                        return new CustomEvent(name);
                    } else {
                        var evt = document.createEvent('CustomEvent');
                        evt.initCustomEvent(name, false, false, undefined);
                        return evt;
                    }
                }

                function processScrollDiff(
                    i,
                    axis,
                    diff,
                    useScrollingClass,
                    forceFireReachEvent
                ) {
                    if (useScrollingClass === void 0) useScrollingClass = true;
                    if (forceFireReachEvent === void 0) forceFireReachEvent = false;

                    var fields;
                    if (axis === 'top') {
                        fields = [
                            'contentHeight',
                            'containerHeight',
                            'scrollTop',
                            'y',
                            'up',
                            'down'
                        ];
                    } else if (axis === 'left') {
                        fields = [
                            'contentWidth',
                            'containerWidth',
                            'scrollLeft',
                            'x',
                            'left',
                            'right'
                        ];
                    } else {
                        throw new Error('A proper axis should be provided');
                    }

                    processScrollDiff$1(i, diff, fields, useScrollingClass, forceFireReachEvent);
                }

                function processScrollDiff$1(
                    i,
                    diff,
                    ref,
                    useScrollingClass,
                    forceFireReachEvent
                ) {
                    var contentHeight = ref[0];
                    var containerHeight = ref[1];
                    var scrollTop = ref[2];
                    var y = ref[3];
                    var up = ref[4];
                    var down = ref[5];
                    if (useScrollingClass === void 0) useScrollingClass = true;
                    if (forceFireReachEvent === void 0) forceFireReachEvent = false;

                    var element = i.element;

                    // reset reach
                    i.reach[y] = null;

                    // 1 for subpixel rounding
                    if (element[scrollTop] < 1) {
                        i.reach[y] = 'start';
                    }

                    // 1 for subpixel rounding
                    if (element[scrollTop] > i[contentHeight] - i[containerHeight] - 1) {
                        i.reach[y] = 'end';
                    }

                    if (diff) {
                        element.dispatchEvent(createEvent(("ps-scroll-" + y)));

                        if (diff < 0) {
                            element.dispatchEvent(createEvent(("ps-scroll-" + up)));
                        } else if (diff > 0) {
                            element.dispatchEvent(createEvent(("ps-scroll-" + down)));
                        }

                        if (useScrollingClass) {
                            setScrollingClassInstantly(i, y);
                        }
                    }

                    if (i.reach[y] && (diff || forceFireReachEvent)) {
                        element.dispatchEvent(createEvent(("ps-" + y + "-reach-" + (i.reach[y]))));
                    }
                }

                function toInt(x) {
                    return parseInt(x, 10) || 0;
                }

                function isEditable(el) {
                    return (
                        matches(el, 'input,[contenteditable]') ||
                        matches(el, 'select,[contenteditable]') ||
                        matches(el, 'textarea,[contenteditable]') ||
                        matches(el, 'button,[contenteditable]')
                    );
                }

                function perfect_scrollbar_esm_outerWidth(element) {
                    var styles = get(element);
                    return (
                        toInt(styles.width) +
                        toInt(styles.paddingLeft) +
                        toInt(styles.paddingRight) +
                        toInt(styles.borderLeftWidth) +
                        toInt(styles.borderRightWidth)
                    );
                }

                var env = {
                    isWebKit: typeof document !== 'undefined' &&
                        'WebkitAppearance' in document.documentElement.style,
                    supportsTouch: typeof window !== 'undefined' &&
                        ('ontouchstart' in window ||
                            ('maxTouchPoints' in window.navigator &&
                                window.navigator.maxTouchPoints > 0) ||
                            (window.DocumentTouch && document instanceof window.DocumentTouch)),
                    supportsIePointer: typeof navigator !== 'undefined' && navigator.msMaxTouchPoints,
                    isChrome: typeof navigator !== 'undefined' &&
                        /Chrome/i.test(navigator && navigator.userAgent),
                };

                function updateGeometry(i) {
                    var element = i.element;
                    var roundedScrollTop = Math.floor(element.scrollTop);
                    var rect = element.getBoundingClientRect();

                    i.containerWidth = Math.round(rect.width);
                    i.containerHeight = Math.round(rect.height);

                    i.contentWidth = element.scrollWidth;
                    i.contentHeight = element.scrollHeight;

                    if (!element.contains(i.scrollbarXRail)) {
                        // clean up and append
                        queryChildren(element, cls.element.rail('x')).forEach(function(el) {
                            return remove(el);
                        });
                        element.appendChild(i.scrollbarXRail);
                    }
                    if (!element.contains(i.scrollbarYRail)) {
                        // clean up and append
                        queryChildren(element, cls.element.rail('y')).forEach(function(el) {
                            return remove(el);
                        });
                        element.appendChild(i.scrollbarYRail);
                    }

                    if (
                        !i.settings.suppressScrollX &&
                        i.containerWidth + i.settings.scrollXMarginOffset < i.contentWidth
                    ) {
                        i.scrollbarXActive = true;
                        i.railXWidth = i.containerWidth - i.railXMarginWidth;
                        i.railXRatio = i.containerWidth / i.railXWidth;
                        i.scrollbarXWidth = getThumbSize(
                            i,
                            toInt((i.railXWidth * i.containerWidth) / i.contentWidth)
                        );
                        i.scrollbarXLeft = toInt(
                            ((i.negativeScrollAdjustment + element.scrollLeft) *
                                (i.railXWidth - i.scrollbarXWidth)) /
                            (i.contentWidth - i.containerWidth)
                        );
                    } else {
                        i.scrollbarXActive = false;
                    }

                    if (
                        !i.settings.suppressScrollY &&
                        i.containerHeight + i.settings.scrollYMarginOffset < i.contentHeight
                    ) {
                        i.scrollbarYActive = true;
                        i.railYHeight = i.containerHeight - i.railYMarginHeight;
                        i.railYRatio = i.containerHeight / i.railYHeight;
                        i.scrollbarYHeight = getThumbSize(
                            i,
                            toInt((i.railYHeight * i.containerHeight) / i.contentHeight)
                        );
                        i.scrollbarYTop = toInt(
                            (roundedScrollTop * (i.railYHeight - i.scrollbarYHeight)) /
                            (i.contentHeight - i.containerHeight)
                        );
                    } else {
                        i.scrollbarYActive = false;
                    }

                    if (i.scrollbarXLeft >= i.railXWidth - i.scrollbarXWidth) {
                        i.scrollbarXLeft = i.railXWidth - i.scrollbarXWidth;
                    }
                    if (i.scrollbarYTop >= i.railYHeight - i.scrollbarYHeight) {
                        i.scrollbarYTop = i.railYHeight - i.scrollbarYHeight;
                    }

                    updateCss(element, i);

                    if (i.scrollbarXActive) {
                        element.classList.add(cls.state.active('x'));
                    } else {
                        element.classList.remove(cls.state.active('x'));
                        i.scrollbarXWidth = 0;
                        i.scrollbarXLeft = 0;
                        element.scrollLeft = i.isRtl === true ? i.contentWidth : 0;
                    }
                    if (i.scrollbarYActive) {
                        element.classList.add(cls.state.active('y'));
                    } else {
                        element.classList.remove(cls.state.active('y'));
                        i.scrollbarYHeight = 0;
                        i.scrollbarYTop = 0;
                        element.scrollTop = 0;
                    }
                }

                function getThumbSize(i, thumbSize) {
                    if (i.settings.minScrollbarLength) {
                        thumbSize = Math.max(thumbSize, i.settings.minScrollbarLength);
                    }
                    if (i.settings.maxScrollbarLength) {
                        thumbSize = Math.min(thumbSize, i.settings.maxScrollbarLength);
                    }
                    return thumbSize;
                }

                function updateCss(element, i) {
                    var xRailOffset = {
                        width: i.railXWidth
                    };
                    var roundedScrollTop = Math.floor(element.scrollTop);

                    if (i.isRtl) {
                        xRailOffset.left =
                            i.negativeScrollAdjustment +
                            element.scrollLeft +
                            i.containerWidth -
                            i.contentWidth;
                    } else {
                        xRailOffset.left = element.scrollLeft;
                    }
                    if (i.isScrollbarXUsingBottom) {
                        xRailOffset.bottom = i.scrollbarXBottom - roundedScrollTop;
                    } else {
                        xRailOffset.top = i.scrollbarXTop + roundedScrollTop;
                    }
                    set(i.scrollbarXRail, xRailOffset);

                    var yRailOffset = {
                        top: roundedScrollTop,
                        height: i.railYHeight
                    };
                    if (i.isScrollbarYUsingRight) {
                        if (i.isRtl) {
                            yRailOffset.right =
                                i.contentWidth -
                                (i.negativeScrollAdjustment + element.scrollLeft) -
                                i.scrollbarYRight -
                                i.scrollbarYOuterWidth -
                                9;
                        } else {
                            yRailOffset.right = i.scrollbarYRight - element.scrollLeft;
                        }
                    } else {
                        if (i.isRtl) {
                            yRailOffset.left =
                                i.negativeScrollAdjustment +
                                element.scrollLeft +
                                i.containerWidth * 2 -
                                i.contentWidth -
                                i.scrollbarYLeft -
                                i.scrollbarYOuterWidth;
                        } else {
                            yRailOffset.left = i.scrollbarYLeft + element.scrollLeft;
                        }
                    }
                    set(i.scrollbarYRail, yRailOffset);

                    set(i.scrollbarX, {
                        left: i.scrollbarXLeft,
                        width: i.scrollbarXWidth - i.railBorderXWidth,
                    });
                    set(i.scrollbarY, {
                        top: i.scrollbarYTop,
                        height: i.scrollbarYHeight - i.railBorderYWidth,
                    });
                }

                function clickRail(i) {
                    var element = i.element;

                    i.event.bind(i.scrollbarY, 'mousedown', function(e) {
                        return e.stopPropagation();
                    });
                    i.event.bind(i.scrollbarYRail, 'mousedown', function(e) {
                        var positionTop =
                            e.pageY -
                            window.pageYOffset -
                            i.scrollbarYRail.getBoundingClientRect().top;
                        var direction = positionTop > i.scrollbarYTop ? 1 : -1;

                        i.element.scrollTop += direction * i.containerHeight;
                        updateGeometry(i);

                        e.stopPropagation();
                    });

                    i.event.bind(i.scrollbarX, 'mousedown', function(e) {
                        return e.stopPropagation();
                    });
                    i.event.bind(i.scrollbarXRail, 'mousedown', function(e) {
                        var positionLeft =
                            e.pageX -
                            window.pageXOffset -
                            i.scrollbarXRail.getBoundingClientRect().left;
                        var direction = positionLeft > i.scrollbarXLeft ? 1 : -1;

                        i.element.scrollLeft += direction * i.containerWidth;
                        updateGeometry(i);

                        e.stopPropagation();
                    });
                }

                function dragThumb(i) {
                    bindMouseScrollHandler(i, [
                        'containerWidth',
                        'contentWidth',
                        'pageX',
                        'railXWidth',
                        'scrollbarX',
                        'scrollbarXWidth',
                        'scrollLeft',
                        'x',
                        'scrollbarXRail'
                    ]);
                    bindMouseScrollHandler(i, [
                        'containerHeight',
                        'contentHeight',
                        'pageY',
                        'railYHeight',
                        'scrollbarY',
                        'scrollbarYHeight',
                        'scrollTop',
                        'y',
                        'scrollbarYRail'
                    ]);
                }

                function bindMouseScrollHandler(
                    i,
                    ref
                ) {
                    var containerHeight = ref[0];
                    var contentHeight = ref[1];
                    var pageY = ref[2];
                    var railYHeight = ref[3];
                    var scrollbarY = ref[4];
                    var scrollbarYHeight = ref[5];
                    var scrollTop = ref[6];
                    var y = ref[7];
                    var scrollbarYRail = ref[8];

                    var element = i.element;

                    var startingScrollTop = null;
                    var startingMousePageY = null;
                    var scrollBy = null;

                    function mouseMoveHandler(e) {
                        if (e.touches && e.touches[0]) {
                            e[pageY] = e.touches[0].pageY;
                        }
                        element[scrollTop] =
                            startingScrollTop + scrollBy * (e[pageY] - startingMousePageY);
                        addScrollingClass(i, y);
                        updateGeometry(i);

                        e.stopPropagation();
                        if (e.type.startsWith('touch') && e.changedTouches.length > 1) {
                            e.preventDefault();
                        }
                    }

                    function mouseUpHandler() {
                        removeScrollingClass(i, y);
                        i[scrollbarYRail].classList.remove(cls.state.clicking);
                        i.event.unbind(i.ownerDocument, 'mousemove', mouseMoveHandler);
                    }

                    function bindMoves(e, touchMode) {
                        startingScrollTop = element[scrollTop];
                        if (touchMode && e.touches) {
                            e[pageY] = e.touches[0].pageY;
                        }
                        startingMousePageY = e[pageY];
                        scrollBy =
                            (i[contentHeight] - i[containerHeight]) /
                            (i[railYHeight] - i[scrollbarYHeight]);
                        if (!touchMode) {
                            i.event.bind(i.ownerDocument, 'mousemove', mouseMoveHandler);
                            i.event.once(i.ownerDocument, 'mouseup', mouseUpHandler);
                            e.preventDefault();
                        } else {
                            i.event.bind(i.ownerDocument, 'touchmove', mouseMoveHandler);
                        }

                        i[scrollbarYRail].classList.add(cls.state.clicking);

                        e.stopPropagation();
                    }

                    i.event.bind(i[scrollbarY], 'mousedown', function(e) {
                        bindMoves(e);
                    });
                    i.event.bind(i[scrollbarY], 'touchstart', function(e) {
                        bindMoves(e, true);
                    });
                }

                function keyboard(i) {
                    var element = i.element;

                    var elementHovered = function() {
                        return matches(element, ':hover');
                    };
                    var scrollbarFocused = function() {
                        return matches(i.scrollbarX, ':focus') || matches(i.scrollbarY, ':focus');
                    };

                    function shouldPreventDefault(deltaX, deltaY) {
                        var scrollTop = Math.floor(element.scrollTop);
                        if (deltaX === 0) {
                            if (!i.scrollbarYActive) {
                                return false;
                            }
                            if (
                                (scrollTop === 0 && deltaY > 0) ||
                                (scrollTop >= i.contentHeight - i.containerHeight && deltaY < 0)
                            ) {
                                return !i.settings.wheelPropagation;
                            }
                        }

                        var scrollLeft = element.scrollLeft;
                        if (deltaY === 0) {
                            if (!i.scrollbarXActive) {
                                return false;
                            }
                            if (
                                (scrollLeft === 0 && deltaX < 0) ||
                                (scrollLeft >= i.contentWidth - i.containerWidth && deltaX > 0)
                            ) {
                                return !i.settings.wheelPropagation;
                            }
                        }
                        return true;
                    }

                    i.event.bind(i.ownerDocument, 'keydown', function(e) {
                        if (
                            (e.isDefaultPrevented && e.isDefaultPrevented()) ||
                            e.defaultPrevented
                        ) {
                            return;
                        }

                        if (!elementHovered() && !scrollbarFocused()) {
                            return;
                        }

                        var activeElement = document.activeElement ?
                            document.activeElement :
                            i.ownerDocument.activeElement;
                        if (activeElement) {
                            if (activeElement.tagName === 'IFRAME') {
                                activeElement = activeElement.contentDocument.activeElement;
                            } else {
                                // go deeper if element is a webcomponent
                                while (activeElement.shadowRoot) {
                                    activeElement = activeElement.shadowRoot.activeElement;
                                }
                            }
                            if (isEditable(activeElement)) {
                                return;
                            }
                        }

                        var deltaX = 0;
                        var deltaY = 0;

                        switch (e.which) {
                            case 37: // left
                                if (e.metaKey) {
                                    deltaX = -i.contentWidth;
                                } else if (e.altKey) {
                                    deltaX = -i.containerWidth;
                                } else {
                                    deltaX = -30;
                                }
                                break;
                            case 38: // up
                                if (e.metaKey) {
                                    deltaY = i.contentHeight;
                                } else if (e.altKey) {
                                    deltaY = i.containerHeight;
                                } else {
                                    deltaY = 30;
                                }
                                break;
                            case 39: // right
                                if (e.metaKey) {
                                    deltaX = i.contentWidth;
                                } else if (e.altKey) {
                                    deltaX = i.containerWidth;
                                } else {
                                    deltaX = 30;
                                }
                                break;
                            case 40: // down
                                if (e.metaKey) {
                                    deltaY = -i.contentHeight;
                                } else if (e.altKey) {
                                    deltaY = -i.containerHeight;
                                } else {
                                    deltaY = -30;
                                }
                                break;
                            case 32: // space bar
                                if (e.shiftKey) {
                                    deltaY = i.containerHeight;
                                } else {
                                    deltaY = -i.containerHeight;
                                }
                                break;
                            case 33: // page up
                                deltaY = i.containerHeight;
                                break;
                            case 34: // page down
                                deltaY = -i.containerHeight;
                                break;
                            case 36: // home
                                deltaY = i.contentHeight;
                                break;
                            case 35: // end
                                deltaY = -i.contentHeight;
                                break;
                            default:
                                return;
                        }

                        if (i.settings.suppressScrollX && deltaX !== 0) {
                            return;
                        }
                        if (i.settings.suppressScrollY && deltaY !== 0) {
                            return;
                        }

                        element.scrollTop -= deltaY;
                        element.scrollLeft += deltaX;
                        updateGeometry(i);

                        if (shouldPreventDefault(deltaX, deltaY)) {
                            e.preventDefault();
                        }
                    });
                }

                function wheel(i) {
                    var element = i.element;

                    function shouldPreventDefault(deltaX, deltaY) {
                        var roundedScrollTop = Math.floor(element.scrollTop);
                        var isTop = element.scrollTop === 0;
                        var isBottom =
                            roundedScrollTop + element.offsetHeight === element.scrollHeight;
                        var isLeft = element.scrollLeft === 0;
                        var isRight =
                            element.scrollLeft + element.offsetWidth === element.scrollWidth;

                        var hitsBound;

                        // pick axis with primary direction
                        if (Math.abs(deltaY) > Math.abs(deltaX)) {
                            hitsBound = isTop || isBottom;
                        } else {
                            hitsBound = isLeft || isRight;
                        }

                        return hitsBound ? !i.settings.wheelPropagation : true;
                    }

                    function getDeltaFromEvent(e) {
                        var deltaX = e.deltaX;
                        var deltaY = -1 * e.deltaY;

                        if (typeof deltaX === 'undefined' || typeof deltaY === 'undefined') {
                            // OS X Safari
                            deltaX = (-1 * e.wheelDeltaX) / 6;
                            deltaY = e.wheelDeltaY / 6;
                        }

                        if (e.deltaMode && e.deltaMode === 1) {
                            // Firefox in deltaMode 1: Line scrolling
                            deltaX *= 10;
                            deltaY *= 10;
                        }

                        if (deltaX !== deltaX && deltaY !== deltaY /* NaN checks */ ) {
                            // IE in some mouse drivers
                            deltaX = 0;
                            deltaY = e.wheelDelta;
                        }

                        if (e.shiftKey) {
                            // reverse axis with shift key
                            return [-deltaY, -deltaX];
                        }
                        return [deltaX, deltaY];
                    }

                    function shouldBeConsumedByChild(target, deltaX, deltaY) {
                        // FIXME: this is a workaround for <select> issue in FF and IE #571
                        if (!env.isWebKit && element.querySelector('select:focus')) {
                            return true;
                        }

                        if (!element.contains(target)) {
                            return false;
                        }

                        var cursor = target;

                        while (cursor && cursor !== element) {
                            if (cursor.classList.contains(cls.element.consuming)) {
                                return true;
                            }

                            var style = get(cursor);

                            // if deltaY && vertical scrollable
                            if (deltaY && style.overflowY.match(/(scroll|auto)/)) {
                                var maxScrollTop = cursor.scrollHeight - cursor.clientHeight;
                                if (maxScrollTop > 0) {
                                    if (
                                        (cursor.scrollTop > 0 && deltaY < 0) ||
                                        (cursor.scrollTop < maxScrollTop && deltaY > 0)
                                    ) {
                                        return true;
                                    }
                                }
                            }
                            // if deltaX && horizontal scrollable
                            if (deltaX && style.overflowX.match(/(scroll|auto)/)) {
                                var maxScrollLeft = cursor.scrollWidth - cursor.clientWidth;
                                if (maxScrollLeft > 0) {
                                    if (
                                        (cursor.scrollLeft > 0 && deltaX < 0) ||
                                        (cursor.scrollLeft < maxScrollLeft && deltaX > 0)
                                    ) {
                                        return true;
                                    }
                                }
                            }

                            cursor = cursor.parentNode;
                        }

                        return false;
                    }

                    function mousewheelHandler(e) {
                        var ref = getDeltaFromEvent(e);
                        var deltaX = ref[0];
                        var deltaY = ref[1];

                        if (shouldBeConsumedByChild(e.target, deltaX, deltaY)) {
                            return;
                        }

                        var shouldPrevent = false;
                        if (!i.settings.useBothWheelAxes) {
                            // deltaX will only be used for horizontal scrolling and deltaY will
                            // only be used for vertical scrolling - this is the default
                            element.scrollTop -= deltaY * i.settings.wheelSpeed;
                            element.scrollLeft += deltaX * i.settings.wheelSpeed;
                        } else if (i.scrollbarYActive && !i.scrollbarXActive) {
                            // only vertical scrollbar is active and useBothWheelAxes option is
                            // active, so let's scroll vertical bar using both mouse wheel axes
                            if (deltaY) {
                                element.scrollTop -= deltaY * i.settings.wheelSpeed;
                            } else {
                                element.scrollTop += deltaX * i.settings.wheelSpeed;
                            }
                            shouldPrevent = true;
                        } else if (i.scrollbarXActive && !i.scrollbarYActive) {
                            // useBothWheelAxes and only horizontal bar is active, so use both
                            // wheel axes for horizontal bar
                            if (deltaX) {
                                element.scrollLeft += deltaX * i.settings.wheelSpeed;
                            } else {
                                element.scrollLeft -= deltaY * i.settings.wheelSpeed;
                            }
                            shouldPrevent = true;
                        }

                        updateGeometry(i);

                        shouldPrevent = shouldPrevent || shouldPreventDefault(deltaX, deltaY);
                        if (shouldPrevent && !e.ctrlKey) {
                            e.stopPropagation();
                            e.preventDefault();
                        }
                    }

                    if (typeof window.onwheel !== 'undefined') {
                        i.event.bind(element, 'wheel', mousewheelHandler);
                    } else if (typeof window.onmousewheel !== 'undefined') {
                        i.event.bind(element, 'mousewheel', mousewheelHandler);
                    }
                }

                function touch(i) {
                    if (!env.supportsTouch && !env.supportsIePointer) {
                        return;
                    }

                    var element = i.element;

                    function shouldPrevent(deltaX, deltaY) {
                        var scrollTop = Math.floor(element.scrollTop);
                        var scrollLeft = element.scrollLeft;
                        var magnitudeX = Math.abs(deltaX);
                        var magnitudeY = Math.abs(deltaY);

                        if (magnitudeY > magnitudeX) {
                            // user is perhaps trying to swipe up/down the page

                            if (
                                (deltaY < 0 && scrollTop === i.contentHeight - i.containerHeight) ||
                                (deltaY > 0 && scrollTop === 0)
                            ) {
                                // set prevent for mobile Chrome refresh
                                return window.scrollY === 0 && deltaY > 0 && env.isChrome;
                            }
                        } else if (magnitudeX > magnitudeY) {
                            // user is perhaps trying to swipe left/right across the page

                            if (
                                (deltaX < 0 && scrollLeft === i.contentWidth - i.containerWidth) ||
                                (deltaX > 0 && scrollLeft === 0)
                            ) {
                                return true;
                            }
                        }

                        return true;
                    }

                    function applyTouchMove(differenceX, differenceY) {
                        element.scrollTop -= differenceY;
                        element.scrollLeft -= differenceX;

                        updateGeometry(i);
                    }

                    var startOffset = {};
                    var startTime = 0;
                    var speed = {};
                    var easingLoop = null;

                    function getTouch(e) {
                        if (e.targetTouches) {
                            return e.targetTouches[0];
                        } else {
                            // Maybe IE pointer
                            return e;
                        }
                    }

                    function shouldHandle(e) {
                        if (e.pointerType && e.pointerType === 'pen' && e.buttons === 0) {
                            return false;
                        }
                        if (e.targetTouches && e.targetTouches.length === 1) {
                            return true;
                        }
                        if (
                            e.pointerType &&
                            e.pointerType !== 'mouse' &&
                            e.pointerType !== e.MSPOINTER_TYPE_MOUSE
                        ) {
                            return true;
                        }
                        return false;
                    }

                    function touchStart(e) {
                        if (!shouldHandle(e)) {
                            return;
                        }

                        var touch = getTouch(e);

                        startOffset.pageX = touch.pageX;
                        startOffset.pageY = touch.pageY;

                        startTime = new Date().getTime();

                        if (easingLoop !== null) {
                            clearInterval(easingLoop);
                        }
                    }

                    function shouldBeConsumedByChild(target, deltaX, deltaY) {
                        if (!element.contains(target)) {
                            return false;
                        }

                        var cursor = target;

                        while (cursor && cursor !== element) {
                            if (cursor.classList.contains(cls.element.consuming)) {
                                return true;
                            }

                            var style = get(cursor);

                            // if deltaY && vertical scrollable
                            if (deltaY && style.overflowY.match(/(scroll|auto)/)) {
                                var maxScrollTop = cursor.scrollHeight - cursor.clientHeight;
                                if (maxScrollTop > 0) {
                                    if (
                                        (cursor.scrollTop > 0 && deltaY < 0) ||
                                        (cursor.scrollTop < maxScrollTop && deltaY > 0)
                                    ) {
                                        return true;
                                    }
                                }
                            }
                            // if deltaX && horizontal scrollable
                            if (deltaX && style.overflowX.match(/(scroll|auto)/)) {
                                var maxScrollLeft = cursor.scrollWidth - cursor.clientWidth;
                                if (maxScrollLeft > 0) {
                                    if (
                                        (cursor.scrollLeft > 0 && deltaX < 0) ||
                                        (cursor.scrollLeft < maxScrollLeft && deltaX > 0)
                                    ) {
                                        return true;
                                    }
                                }
                            }

                            cursor = cursor.parentNode;
                        }

                        return false;
                    }

                    function touchMove(e) {
                        if (shouldHandle(e)) {
                            var touch = getTouch(e);

                            var currentOffset = {
                                pageX: touch.pageX,
                                pageY: touch.pageY
                            };

                            var differenceX = currentOffset.pageX - startOffset.pageX;
                            var differenceY = currentOffset.pageY - startOffset.pageY;

                            if (shouldBeConsumedByChild(e.target, differenceX, differenceY)) {
                                return;
                            }

                            applyTouchMove(differenceX, differenceY);
                            startOffset = currentOffset;

                            var currentTime = new Date().getTime();

                            var timeGap = currentTime - startTime;
                            if (timeGap > 0) {
                                speed.x = differenceX / timeGap;
                                speed.y = differenceY / timeGap;
                                startTime = currentTime;
                            }

                            if (shouldPrevent(differenceX, differenceY)) {
                                e.preventDefault();
                            }
                        }
                    }

                    function touchEnd() {
                        if (i.settings.swipeEasing) {
                            clearInterval(easingLoop);
                            easingLoop = setInterval(function() {
                                if (i.isInitialized) {
                                    clearInterval(easingLoop);
                                    return;
                                }

                                if (!speed.x && !speed.y) {
                                    clearInterval(easingLoop);
                                    return;
                                }

                                if (Math.abs(speed.x) < 0.01 && Math.abs(speed.y) < 0.01) {
                                    clearInterval(easingLoop);
                                    return;
                                }

                                if (!i.element) {
                                    clearInterval(easingLoop);
                                    return;
                                }

                                applyTouchMove(speed.x * 30, speed.y * 30);

                                speed.x *= 0.8;
                                speed.y *= 0.8;
                            }, 10);
                        }
                    }

                    if (env.supportsTouch) {
                        i.event.bind(element, 'touchstart', touchStart);
                        i.event.bind(element, 'touchmove', touchMove);
                        i.event.bind(element, 'touchend', touchEnd);
                    } else if (env.supportsIePointer) {
                        if (window.PointerEvent) {
                            i.event.bind(element, 'pointerdown', touchStart);
                            i.event.bind(element, 'pointermove', touchMove);
                            i.event.bind(element, 'pointerup', touchEnd);
                        } else if (window.MSPointerEvent) {
                            i.event.bind(element, 'MSPointerDown', touchStart);
                            i.event.bind(element, 'MSPointerMove', touchMove);
                            i.event.bind(element, 'MSPointerUp', touchEnd);
                        }
                    }
                }

                var defaultSettings = function() {
                    return ({
                        handlers: ['click-rail', 'drag-thumb', 'keyboard', 'wheel', 'touch'],
                        maxScrollbarLength: null,
                        minScrollbarLength: null,
                        scrollingThreshold: 1000,
                        scrollXMarginOffset: 0,
                        scrollYMarginOffset: 0,
                        suppressScrollX: false,
                        suppressScrollY: false,
                        swipeEasing: true,
                        useBothWheelAxes: false,
                        wheelPropagation: true,
                        wheelSpeed: 1,
                    });
                };

                var handlers = {
                    'click-rail': clickRail,
                    'drag-thumb': dragThumb,
                    keyboard: keyboard,
                    wheel: wheel,
                    touch: touch,
                };

                var PerfectScrollbar = function PerfectScrollbar(element, userSettings) {
                    var this$1 = this;
                    if (userSettings === void 0) userSettings = {};

                    if (typeof element === 'string') {
                        element = document.querySelector(element);
                    }

                    if (!element || !element.nodeName) {
                        throw new Error('no element is specified to initialize PerfectScrollbar');
                    }

                    this.element = element;

                    element.classList.add(cls.main);

                    this.settings = defaultSettings();
                    for (var key in userSettings) {
                        this.settings[key] = userSettings[key];
                    }

                    this.containerWidth = null;
                    this.containerHeight = null;
                    this.contentWidth = null;
                    this.contentHeight = null;

                    var focus = function() {
                        return element.classList.add(cls.state.focus);
                    };
                    var blur = function() {
                        return element.classList.remove(cls.state.focus);
                    };

                    this.isRtl = get(element).direction === 'rtl';
                    if (this.isRtl === true) {
                        element.classList.add(cls.rtl);
                    }
                    this.isNegativeScroll = (function() {
                        var originalScrollLeft = element.scrollLeft;
                        var result = null;
                        element.scrollLeft = -1;
                        result = element.scrollLeft < 0;
                        element.scrollLeft = originalScrollLeft;
                        return result;
                    })();
                    this.negativeScrollAdjustment = this.isNegativeScroll ?
                        element.scrollWidth - element.clientWidth :
                        0;
                    this.event = new EventManager();
                    this.ownerDocument = element.ownerDocument || document;

                    this.scrollbarXRail = div(cls.element.rail('x'));
                    element.appendChild(this.scrollbarXRail);
                    this.scrollbarX = div(cls.element.thumb('x'));
                    this.scrollbarXRail.appendChild(this.scrollbarX);
                    this.scrollbarX.setAttribute('tabindex', 0);
                    this.event.bind(this.scrollbarX, 'focus', focus);
                    this.event.bind(this.scrollbarX, 'blur', blur);
                    this.scrollbarXActive = null;
                    this.scrollbarXWidth = null;
                    this.scrollbarXLeft = null;
                    var railXStyle = get(this.scrollbarXRail);
                    this.scrollbarXBottom = parseInt(railXStyle.bottom, 10);
                    if (isNaN(this.scrollbarXBottom)) {
                        this.isScrollbarXUsingBottom = false;
                        this.scrollbarXTop = toInt(railXStyle.top);
                    } else {
                        this.isScrollbarXUsingBottom = true;
                    }
                    this.railBorderXWidth =
                        toInt(railXStyle.borderLeftWidth) + toInt(railXStyle.borderRightWidth);
                    // Set rail to display:block to calculate margins
                    set(this.scrollbarXRail, {
                        display: 'block'
                    });
                    this.railXMarginWidth =
                        toInt(railXStyle.marginLeft) + toInt(railXStyle.marginRight);
                    set(this.scrollbarXRail, {
                        display: ''
                    });
                    this.railXWidth = null;
                    this.railXRatio = null;

                    this.scrollbarYRail = div(cls.element.rail('y'));
                    element.appendChild(this.scrollbarYRail);
                    this.scrollbarY = div(cls.element.thumb('y'));
                    this.scrollbarYRail.appendChild(this.scrollbarY);
                    this.scrollbarY.setAttribute('tabindex', 0);
                    this.event.bind(this.scrollbarY, 'focus', focus);
                    this.event.bind(this.scrollbarY, 'blur', blur);
                    this.scrollbarYActive = null;
                    this.scrollbarYHeight = null;
                    this.scrollbarYTop = null;
                    var railYStyle = get(this.scrollbarYRail);
                    this.scrollbarYRight = parseInt(railYStyle.right, 10);
                    if (isNaN(this.scrollbarYRight)) {
                        this.isScrollbarYUsingRight = false;
                        this.scrollbarYLeft = toInt(railYStyle.left);
                    } else {
                        this.isScrollbarYUsingRight = true;
                    }
                    this.scrollbarYOuterWidth = this.isRtl ? perfect_scrollbar_esm_outerWidth(this.scrollbarY) : null;
                    this.railBorderYWidth =
                        toInt(railYStyle.borderTopWidth) + toInt(railYStyle.borderBottomWidth);
                    set(this.scrollbarYRail, {
                        display: 'block'
                    });
                    this.railYMarginHeight =
                        toInt(railYStyle.marginTop) + toInt(railYStyle.marginBottom);
                    set(this.scrollbarYRail, {
                        display: ''
                    });
                    this.railYHeight = null;
                    this.railYRatio = null;

                    this.reach = {
                        x: element.scrollLeft <= 0 ?
                            'start' :
                            element.scrollLeft >= this.contentWidth - this.containerWidth ?
                            'end' :
                            null,
                        y: element.scrollTop <= 0 ?
                            'start' :
                            element.scrollTop >= this.contentHeight - this.containerHeight ?
                            'end' :
                            null,
                    };

                    this.isAlive = true;

                    this.settings.handlers.forEach(function(handlerName) {
                        return handlers[handlerName](this$1);
                    });

                    this.lastScrollTop = Math.floor(element.scrollTop); // for onScroll only
                    this.lastScrollLeft = element.scrollLeft; // for onScroll only
                    this.event.bind(this.element, 'scroll', function(e) {
                        return this$1.onScroll(e);
                    });
                    updateGeometry(this);
                };

                PerfectScrollbar.prototype.update = function update() {
                    if (!this.isAlive) {
                        return;
                    }

                    // Recalcuate negative scrollLeft adjustment
                    this.negativeScrollAdjustment = this.isNegativeScroll ?
                        this.element.scrollWidth - this.element.clientWidth :
                        0;

                    // Recalculate rail margins
                    set(this.scrollbarXRail, {
                        display: 'block'
                    });
                    set(this.scrollbarYRail, {
                        display: 'block'
                    });
                    this.railXMarginWidth =
                        toInt(get(this.scrollbarXRail).marginLeft) +
                        toInt(get(this.scrollbarXRail).marginRight);
                    this.railYMarginHeight =
                        toInt(get(this.scrollbarYRail).marginTop) +
                        toInt(get(this.scrollbarYRail).marginBottom);

                    // Hide scrollbars not to affect scrollWidth and scrollHeight
                    set(this.scrollbarXRail, {
                        display: 'none'
                    });
                    set(this.scrollbarYRail, {
                        display: 'none'
                    });

                    updateGeometry(this);

                    processScrollDiff(this, 'top', 0, false, true);
                    processScrollDiff(this, 'left', 0, false, true);

                    set(this.scrollbarXRail, {
                        display: ''
                    });
                    set(this.scrollbarYRail, {
                        display: ''
                    });
                };

                PerfectScrollbar.prototype.onScroll = function onScroll(e) {
                    if (!this.isAlive) {
                        return;
                    }

                    updateGeometry(this);
                    processScrollDiff(this, 'top', this.element.scrollTop - this.lastScrollTop);
                    processScrollDiff(
                        this,
                        'left',
                        this.element.scrollLeft - this.lastScrollLeft
                    );

                    this.lastScrollTop = Math.floor(this.element.scrollTop);
                    this.lastScrollLeft = this.element.scrollLeft;
                };

                PerfectScrollbar.prototype.destroy = function destroy() {
                    if (!this.isAlive) {
                        return;
                    }

                    this.event.unbindAll();
                    remove(this.scrollbarX);
                    remove(this.scrollbarY);
                    remove(this.scrollbarXRail);
                    remove(this.scrollbarYRail);
                    this.removePsClasses();

                    // unset elements
                    this.element = null;
                    this.scrollbarX = null;
                    this.scrollbarY = null;
                    this.scrollbarXRail = null;
                    this.scrollbarYRail = null;

                    this.isAlive = false;
                };

                PerfectScrollbar.prototype.removePsClasses = function removePsClasses() {
                    this.element.className = this.element.className
                        .split(' ')
                        .filter(function(name) {
                            return !name.match(/^ps([-_].+|)$/);
                        })
                        .join(' ');
                };

                /* harmony default export */
                const perfect_scrollbar_esm = (PerfectScrollbar);
                //# sourceMappingURL=perfect-scrollbar.esm.js.map

                ; // CONCATENATED MODULE: ./src/js/common/inits.js




                const init = {
                    /**
                     * Initialize instant search
                     */
                    search: () => {
                        return new Search();
                    },

                    /**
                     * Initialize Input dates
                     * @returns {*}
                     */
                    dateInputs: () => {
                        return [...document.querySelectorAll('.js-input-date')].map(input => new cleave_esm(input, {
                            date: true,
                            datePattern: input.dataset.format.split(',')
                        }));
                    },

                    /**
                     * Initialize password inputs
                     * @returns {*}
                     */
                    passwordInputs: () => {
                        return [...document.querySelectorAll('.form-field__password')].map(field => {
                            const input = field.querySelector('input');
                            const eye = field.querySelector('.form-field-show-password');
                            const eyeOpen = eye.src;
                            const eyeClose = eye.dataset.img;

                            if (input && eye && eyeOpen && eyeClose) {
                                eye.addEventListener('click', () => {
                                    const visible = eye.classList.contains('visible');

                                    if (visible) {
                                        eye.classList.remove('visible');
                                    } else {
                                        eye.classList.add('visible');
                                    }

                                    eye.src = visible ? eyeOpen : eyeClose;
                                    input.type = visible ? 'password' : 'text';
                                });
                            }

                            return field;
                        });
                    },

                    /**
                     * Initialize custom selects
                     * @returns {*}
                     */
                    customSelects: parent => {
                        return [...parent.querySelectorAll('.js-custom-select')].map(select => (0, build /* default */ .Z)(select));
                    },

                    /**
                     * Initialize custom scrollbars
                     * @param parent
                     * @returns {boolean|*}
                     */
                    scrollbars: parent => {
                        if (typeof parent === "undefined") {
                            console.error('Cannot initialize scrollbars, parent parameter is undefined.');
                            return false;
                        }

                        return [...parent.querySelectorAll('.ps')].map(el => new perfect_scrollbar_esm(el));
                    },

                    /**
                     * Initialize custom video players
                     * @returns {*}
                     */
                    videoPlayers: () => {
                        return [...document.querySelectorAll('.js-plyr')].map(video => new Plyr(video));
                    },

                    /**
                     * Initialize popins
                     */
                    popins: () => {
                        [...document.querySelectorAll('button[data-popin]')].map(btn => {
                            const popin = document.querySelector(`.${btn.dataset.popin}`);

                            if (popin) {
                                popin.querySelector('.js-close-popin').addEventListener('click', e => {
                                    e.preventDefault();
                                    popin.classList.remove('open');
                                    document.body.style.overflowY = 'auto';
                                });
                                btn.addEventListener('click', e => {
                                    e.preventDefault();
                                    popin.classList.add('open');
                                    document.body.style.overflowY = 'hidden';
                                });
                                return {
                                    button: btn,
                                    popin: popin
                                };
                            }
                        });
                    }
                };
                /* harmony default export */
                const inits = (init);; // CONCATENATED MODULE: ./src/js/common.js

                /* common.js */

                /* This file initialize all components used on the whole storefront */
                // Load styles (webpack related)

                // Following functions initialize each common parts
                // Todo externalize initiator properly, make Class ?

                // ---------------------------------------------------------------------------------------------------------------------
                // Events
                // ---------------------------------------------------------------------------------------------------------------------

                window.addEventListener('DOMContentLoaded', () => {
                    inits.dateInputs();
                    inits.passwordInputs();
                    inits.scrollbars(document);
                    inits.customSelects(document);
                    inits.popins();
                    initMobileMenu();
                    document.dispatchEvent(new Event('theme:DOMContentLoaded'));
                }); // Handle search behavior on the main content
                // document.addEventListener('theme:search:queried', () => {
                //   document.querySelector('.main').classList.add('main--search-results-visible');
                // });
                // document.addEventListener('theme:search:closed', () => {
                //   document.querySelector('.main').classList.remove('main--search-results-visible');
                // });//# sourceURL=[module]
                //# sourceMappingURL=data:application/json;charset=utf-8;base64
                //# sourceURL=webpack-internal:///2015

            },
            3711: () => {
                // Polyfill for creating CustomEvents on IE9/10/11

                // code pulled from:
                // https://github.com/d4tocchini/customevent-polyfill
                // https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent#Polyfill

                try {
                    var ce = new window.CustomEvent('test');
                    ce.preventDefault();
                    if (ce.defaultPrevented !== true) {
                        // IE has problems with .preventDefault() on custom events
                        // http://stackoverflow.com/questions/23349191
                        throw new Error('Could not prevent default');
                    }
                } catch (e) {
                    var CustomEvent = function(event, params) {
                        var evt, origPrevent;
                        params = params || {
                            bubbles: false,
                            cancelable: false,
                            detail: undefined
                        };

                        evt = document.createEvent("CustomEvent");
                        evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
                        origPrevent = evt.preventDefault;
                        evt.preventDefault = function() {
                            origPrevent.call(this);
                            try {
                                Object.defineProperty(this, 'defaultPrevented', {
                                    get: function() {
                                        return true;
                                    }
                                });
                            } catch (e) {
                                this.defaultPrevented = true;
                            }
                        };
                        return evt;
                    };

                    CustomEvent.prototype = window.Event.prototype;
                    window.CustomEvent = CustomEvent; // expose definition to window
                }
                //# sourceURL=[module]
                //# sourceMappingURL=data:application/json;charset=utf-8;base64
                //# sourceURL=webpack-internal:///3711

            },
            9060: (__unused_webpack_module, exports, __webpack_require__) => {
                "use strict";
                var __webpack_unused_export__;


                __webpack_unused_export__ = ({
                    value: true
                });

                var _extends = Object.assign || function(target) {
                    for (var i = 1; i < arguments.length; i++) {
                        var source = arguments[i];
                        for (var key in source) {
                            if (Object.prototype.hasOwnProperty.call(source, key)) {
                                target[key] = source[key];
                            }
                        }
                    }
                    return target;
                };

                var _slicedToArray = function() {
                    function sliceIterator(arr, i) {
                        var _arr = [];
                        var _n = true;
                        var _d = false;
                        var _e = undefined;
                        try {
                            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                                _arr.push(_s.value);
                                if (i && _arr.length === i) break;
                            }
                        } catch (err) {
                            _d = true;
                            _e = err;
                        } finally {
                            try {
                                if (!_n && _i["return"]) _i["return"]();
                            } finally {
                                if (_d) throw _e;
                            }
                        }
                        return _arr;
                    }
                    return function(arr, i) {
                        if (Array.isArray(arr)) {
                            return arr;
                        } else if (Symbol.iterator in Object(arr)) {
                            return sliceIterator(arr, i);
                        } else {
                            throw new TypeError("Invalid attempt to destructure non-iterable instance");
                        }
                    };
                }();
                /**
                 * custom-select
                 * A lightweight JS script for custom select creation.
                 * Needs no dependencies.
                 *
                 * v0.0.1
                 * (https://github.com/custom-select/custom-select)
                 *
                 * Copyright (c) 2016 Gionatan Lombardi & Marco Nucara
                 * MIT License
                 */

                exports.Z = customSelect;

                __webpack_require__(3711);

                var defaultParams = {
                    containerClass: 'custom-select-container',
                    openerClass: 'custom-select-opener',
                    panelClass: 'custom-select-panel',
                    optionClass: 'custom-select-option',
                    optgroupClass: 'custom-select-optgroup',
                    isSelectedClass: 'is-selected',
                    hasFocusClass: 'has-focus',
                    isDisabledClass: 'is-disabled',
                    isOpenClass: 'is-open'
                };

                function builder(el, builderParams) {
                    var containerClass = 'customSelect';
                    var isOpen = false;
                    var uId = '';
                    var select = el;
                    var container = void 0;
                    var opener = void 0;
                    var focusedElement = void 0;
                    var selectedElement = void 0;
                    var panel = void 0;
                    var currLabel = void 0;

                    var resetSearchTimeout = void 0;
                    var searchKey = '';

                    //
                    // Inner Functions
                    //

                    // Sets the focused element with the neccessary classes substitutions
                    function setFocusedElement(cstOption) {
                        if (focusedElement) {
                            focusedElement.classList.remove(builderParams.hasFocusClass);
                        }
                        if (typeof cstOption !== 'undefined') {
                            focusedElement = cstOption;
                            focusedElement.classList.add(builderParams.hasFocusClass);
                            // Offset update: checks if the focused element is in the visible part of the panelClass
                            // if not dispatches a custom event
                            if (isOpen) {
                                if (cstOption.offsetTop < cstOption.offsetParent.scrollTop || cstOption.offsetTop > cstOption.offsetParent.scrollTop + cstOption.offsetParent.clientHeight - cstOption.clientHeight) {
                                    cstOption.dispatchEvent(new CustomEvent('custom-select:focus-outside-panel', {
                                        bubbles: true
                                    }));
                                }
                            }
                        } else {
                            focusedElement = undefined;
                        }
                    }

                    // Reassigns the focused and selected custom option
                    // Updates the opener text
                    // IMPORTANT: the setSelectedElement function doesn't change the select value!
                    function setSelectedElement(cstOption) {
                        if (selectedElement) {
                            selectedElement.classList.remove(builderParams.isSelectedClass);
                            selectedElement.removeAttribute('id');
                            opener.removeAttribute('aria-activedescendant');
                        }
                        if (typeof cstOption !== 'undefined') {
                            cstOption.classList.add(builderParams.isSelectedClass);
                            cstOption.setAttribute('id', containerClass + '-' + uId + '-selectedOption');
                            opener.setAttribute('aria-activedescendant', containerClass + '-' + uId + '-selectedOption');
                            selectedElement = cstOption;
                            opener.children[0].textContent = selectedElement.customSelectOriginalOption.text;
                        } else {
                            selectedElement = undefined;
                            opener.children[0].textContent = '';
                        }
                        setFocusedElement(cstOption);
                    }

                    function setValue(value) {
                        // Gets the option with the provided value
                        var toSelect = select.querySelector('option[value=\'' + value + '\']');
                        // If no option has the provided value get the first
                        if (!toSelect) {
                            var _select$options = _slicedToArray(select.options, 1);

                            toSelect = _select$options[0];
                        }
                        // The option with the provided value becomes the selected one
                        // And changes the select current value
                        toSelect.selected = true;

                        setSelectedElement(select.options[select.selectedIndex].customSelectCstOption);
                    }

                    function moveFocuesedElement(direction) {
                        // Get all the .custom-select-options
                        // Get the index of the current focused one
                        var currentFocusedIndex = [].indexOf.call(select.options, focusedElement.customSelectOriginalOption);
                        // If the next or prev custom option exist
                        // Sets it as the new focused one
                        if (select.options[currentFocusedIndex + direction]) {
                            setFocusedElement(select.options[currentFocusedIndex + direction].customSelectCstOption);
                        }
                    }

                    // Open/Close function (toggle)
                    function open(bool) {
                        // Open
                        if (bool || typeof bool === 'undefined') {
                            // If present closes an opened instance of the plugin
                            // Only one at time can be open
                            var openedCustomSelect = document.querySelector('.' + containerClass + '.' + builderParams.isOpenClass);
                            if (openedCustomSelect) {
                                openedCustomSelect.customSelect.open = false;
                            }

                            // Opens only the clicked one
                            container.classList.add(builderParams.isOpenClass);

                            // aria-expanded update
                            container.classList.add(builderParams.isOpenClass);
                            opener.setAttribute('aria-expanded', 'true');

                            // Updates the scrollTop position of the panel in relation with the focused option
                            if (selectedElement) {
                                panel.scrollTop = selectedElement.offsetTop;
                            }

                            // Dispatches the custom event open
                            container.dispatchEvent(new CustomEvent('custom-select:open'));

                            // Sets the global state
                            isOpen = true;

                            // Close
                        } else {
                            // Removes the css classes
                            container.classList.remove(builderParams.isOpenClass);

                            // aria-expanded update
                            opener.setAttribute('aria-expanded', 'false');

                            // Sets the global state
                            isOpen = false;

                            // When closing the panel the focused custom option must be the selected one
                            setFocusedElement(selectedElement);

                            // Dispatches the custom event close
                            container.dispatchEvent(new CustomEvent('custom-select:close'));
                        }
                        return isOpen;
                    }

                    function clickEvent(e) {
                        // Opener click
                        if (e.target === opener || opener.contains(e.target)) {
                            if (isOpen) {
                                open(false);
                            } else {
                                open();
                            }
                            // Custom Option click
                        } else if (e.target.classList && e.target.classList.contains(builderParams.optionClass) && panel.contains(e.target)) {
                            setSelectedElement(e.target);
                            // Sets the corrisponding select's option to selected updating the select's value too
                            selectedElement.customSelectOriginalOption.selected = true;
                            open(false);
                            // Triggers the native change event of the select
                            select.dispatchEvent(new CustomEvent('change'));
                            // click on label or select (click on label corrispond to select click)
                        } else if (e.target === select) {
                            // if the original select is focusable (for any external reason) let the focus
                            // else trigger the focus on opener
                            if (opener !== document.activeElement && select !== document.activeElement) {
                                opener.focus();
                            }
                            // Click outside the container closes the panel
                        } else if (isOpen && !container.contains(e.target)) {
                            open(false);
                        }
                    }

                    function mouseoverEvent(e) {
                        // On mouse move over and options it bacames the focused one
                        if (e.target.classList && e.target.classList.contains(builderParams.optionClass)) {
                            setFocusedElement(e.target);
                        }
                    }

                    function keydownEvent(e) {
                        if (!isOpen) {
                            // On "Arrow down", "Arrow up" and "Space" keys opens the panel
                            if (e.keyCode === 40 || e.keyCode === 38 || e.keyCode === 32) {
                                open();
                            }
                        } else {
                            switch (e.keyCode) {
                                case 13:
                                case 32:
                                    // On "Enter" or "Space" selects the focused element as the selected one
                                    setSelectedElement(focusedElement);
                                    // Sets the corrisponding select's option to selected updating the select's value too
                                    selectedElement.customSelectOriginalOption.selected = true;
                                    // Triggers the native change event of the select
                                    select.dispatchEvent(new CustomEvent('change'));
                                    open(false);
                                    break;
                                case 27:
                                    // On "Escape" closes the panel
                                    open(false);
                                    break;

                                case 38:
                                    // On "Arrow up" set focus to the prev option if present
                                    moveFocuesedElement(-1);
                                    break;
                                case 40:
                                    // On "Arrow down" set focus to the next option if present
                                    moveFocuesedElement(+1);
                                    break;
                                default:
                                    // search in panel (autocomplete)
                                    if (e.keyCode >= 48 && e.keyCode <= 90) {
                                        // clear existing reset timeout
                                        if (resetSearchTimeout) {
                                            clearTimeout(resetSearchTimeout);
                                        }

                                        // reset timeout for empty search key
                                        resetSearchTimeout = setTimeout(function() {
                                            searchKey = '';
                                        }, 1500);

                                        // update search keyword appending the current key
                                        searchKey += String.fromCharCode(e.keyCode);

                                        // search the element
                                        for (var i = 0, l = select.options.length; i < l; i++) {
                                            // removed cause not supported by IE:
                                            // if (options[i].text.startsWith(searchKey))
                                            if (select.options[i].text.toUpperCase().substr(0, searchKey.length) === searchKey) {
                                                setFocusedElement(select.options[i].customSelectCstOption);
                                                break;
                                            }
                                        }
                                    }
                                    break;
                            }
                        }
                    }

                    function changeEvent() {
                        var index = select.selectedIndex;
                        var element = index === -1 ? undefined : select.options[index].customSelectCstOption;

                        setSelectedElement(element);
                    }

                    // When the option is outside the visible part of the opened panel, updates the scrollTop position
                    // This is the default behaviour
                    // To block it the plugin user must
                    // add a "custom-select:focus-outside-panel" eventListener on the panel
                    // with useCapture set to true
                    // and stopPropagation
                    function scrollToFocused(e) {
                        var currPanel = e.currentTarget;
                        var currOption = e.target;
                        // Up
                        if (currOption.offsetTop < currPanel.scrollTop) {
                            currPanel.scrollTop = currOption.offsetTop;
                            // Down
                        } else {
                            currPanel.scrollTop = currOption.offsetTop + currOption.clientHeight - currPanel.clientHeight;
                        }
                    }

                    function addEvents() {
                        document.addEventListener('click', clickEvent);
                        panel.addEventListener('mouseover', mouseoverEvent);
                        panel.addEventListener('custom-select:focus-outside-panel', scrollToFocused);
                        select.addEventListener('change', changeEvent);
                        container.addEventListener('keydown', keydownEvent);
                    }

                    function removeEvents() {
                        document.removeEventListener('click', clickEvent);
                        panel.removeEventListener('mouseover', mouseoverEvent);
                        panel.removeEventListener('custom-select:focus-outside-panel', scrollToFocused);
                        select.removeEventListener('change', changeEvent);
                        container.removeEventListener('keydown', keydownEvent);
                    }

                    function disabled(bool) {
                        if (bool && !select.disabled) {
                            container.classList.add(builderParams.isDisabledClass);
                            select.disabled = true;
                            opener.removeAttribute('tabindex');
                            container.dispatchEvent(new CustomEvent('custom-select:disabled'));
                            removeEvents();
                        } else if (!bool && select.disabled) {
                            container.classList.remove(builderParams.isDisabledClass);
                            select.disabled = false;
                            opener.setAttribute('tabindex', '0');
                            container.dispatchEvent(new CustomEvent('custom-select:enabled'));
                            addEvents();
                        }
                    }

                    // Form a given select children DOM tree (options and optgroup),
                    // Creates the corresponding custom HTMLElements list (divs with different classes and attributes)
                    function parseMarkup(children) {
                        var nodeList = children;
                        var cstList = [];

                        if (typeof nodeList.length === 'undefined') {
                            throw new TypeError('Invalid Argument');
                        }

                        for (var i = 0, li = nodeList.length; i < li; i++) {
                            if (nodeList[i] instanceof HTMLElement && nodeList[i].tagName.toUpperCase() === 'OPTGROUP') {
                                var cstOptgroup = document.createElement('div');
                                cstOptgroup.classList.add(builderParams.optgroupClass);
                                cstOptgroup.setAttribute('data-label', nodeList[i].label);

                                // IMPORTANT: Stores in a property of the created custom option group
                                // a hook to the the corrisponding select's option group
                                cstOptgroup.customSelectOriginalOptgroup = nodeList[i];

                                // IMPORTANT: Stores in a property of select's option group
                                // a hook to the created custom option group
                                nodeList[i].customSelectCstOptgroup = cstOptgroup;

                                var subNodes = parseMarkup(nodeList[i].children);
                                for (var j = 0, lj = subNodes.length; j < lj; j++) {
                                    cstOptgroup.appendChild(subNodes[j]);
                                }

                                cstList.push(cstOptgroup);
                            } else if (nodeList[i] instanceof HTMLElement && nodeList[i].tagName.toUpperCase() === 'OPTION') {
                                var cstOption = document.createElement('div');
                                cstOption.classList.add(builderParams.optionClass);
                                cstOption.textContent = nodeList[i].text;
                                cstOption.setAttribute('data-value', nodeList[i].value);
                                cstOption.setAttribute('role', 'option');

                                // IMPORTANT: Stores in a property of the created custom option
                                // a hook to the the corrisponding select's option
                                cstOption.customSelectOriginalOption = nodeList[i];

                                // IMPORTANT: Stores in a property of select's option
                                // a hook to the created custom option
                                nodeList[i].customSelectCstOption = cstOption;

                                // If the select's option is selected
                                if (nodeList[i].selected) {
                                    setSelectedElement(cstOption);
                                }
                                cstList.push(cstOption);
                            } else {
                                throw new TypeError('Invalid Argument');
                            }
                        }
                        return cstList;
                    }

                    function _append(nodePar, appendIntoOriginal, targetPar) {
                        var target = void 0;
                        if (typeof targetPar === 'undefined' || targetPar === select) {
                            target = panel;
                        } else if (targetPar instanceof HTMLElement && targetPar.tagName.toUpperCase() === 'OPTGROUP' && select.contains(targetPar)) {
                            target = targetPar.customSelectCstOptgroup;
                        } else {
                            throw new TypeError('Invalid Argument');
                        }

                        // If the node provided is a single HTMLElement it is stored in an array
                        var node = nodePar instanceof HTMLElement ? [nodePar] : nodePar;

                        // Injects the options|optgroup in the select
                        if (appendIntoOriginal) {
                            for (var i = 0, l = node.length; i < l; i++) {
                                if (target === panel) {
                                    select.appendChild(node[i]);
                                } else {
                                    target.customSelectOriginalOptgroup.appendChild(node[i]);
                                }
                            }
                        }

                        // The custom markup to append
                        var markupToInsert = parseMarkup(node);

                        // Injects the created DOM content in the panel
                        for (var _i = 0, _l = markupToInsert.length; _i < _l; _i++) {
                            target.appendChild(markupToInsert[_i]);
                        }

                        return node;
                    }

                    function _insertBefore(node, targetPar) {
                        var target = void 0;
                        if (targetPar instanceof HTMLElement && targetPar.tagName.toUpperCase() === 'OPTION' && select.contains(targetPar)) {
                            target = targetPar.customSelectCstOption;
                        } else if (targetPar instanceof HTMLElement && targetPar.tagName.toUpperCase() === 'OPTGROUP' && select.contains(targetPar)) {
                            target = targetPar.customSelectCstOptgroup;
                        } else {
                            throw new TypeError('Invalid Argument');
                        }

                        // The custom markup to append
                        var markupToInsert = parseMarkup(node.length ? node : [node]);

                        target.parentNode.insertBefore(markupToInsert[0], target);

                        // Injects the option or optgroup node in the original select and returns the injected node
                        return targetPar.parentNode.insertBefore(node.length ? node[0] : node, targetPar);
                    }

                    function remove(node) {
                        var cstNode = void 0;
                        if (node instanceof HTMLElement && node.tagName.toUpperCase() === 'OPTION' && select.contains(node)) {
                            cstNode = node.customSelectCstOption;
                        } else if (node instanceof HTMLElement && node.tagName.toUpperCase() === 'OPTGROUP' && select.contains(node)) {
                            cstNode = node.customSelectCstOptgroup;
                        } else {
                            throw new TypeError('Invalid Argument');
                        }
                        cstNode.parentNode.removeChild(cstNode);
                        var removedNode = node.parentNode.removeChild(node);
                        changeEvent();
                        return removedNode;
                    }

                    function empty() {
                        var removed = [];
                        while (select.children.length) {
                            panel.removeChild(panel.children[0]);
                            removed.push(select.removeChild(select.children[0]));
                        }
                        setSelectedElement();
                        return removed;
                    }

                    function destroy() {
                        for (var i = 0, l = select.options.length; i < l; i++) {
                            delete select.options[i].customSelectCstOption;
                        }
                        var optGroup = select.getElementsByTagName('optgroup');
                        for (var _i2 = 0, _l2 = optGroup.length; _i2 < _l2; _i2++) {
                            delete optGroup.customSelectCstOptgroup;
                        }

                        removeEvents();

                        return container.parentNode.replaceChild(select, container);
                    }
                    //
                    // Custom Select DOM tree creation
                    //

                    // Creates the container/wrapper
                    container = document.createElement('div');
                    container.classList.add(builderParams.containerClass, containerClass);

                    // Creates the opener
                    opener = document.createElement('span');
                    opener.className = builderParams.openerClass;
                    opener.setAttribute('role', 'combobox');
                    opener.setAttribute('aria-autocomplete', 'list');
                    opener.setAttribute('aria-expanded', 'false');
                    opener.innerHTML = '<span>\n   ' + (select.selectedIndex !== -1 ? select.options[select.selectedIndex].text : '') + '\n   </span>';

                    // Creates the panel
                    // and injects the markup of the select inside
                    // with some tag and attributes replacement
                    panel = document.createElement('div');
                    // Create random id
                    var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
                    for (var i = 0; i < 5; i++) {
                        uId += possible.charAt(Math.floor(Math.random() * possible.length));
                    }
                    panel.id = containerClass + '-' + uId + '-panel';
                    panel.className = builderParams.panelClass;
                    panel.setAttribute('role', 'listbox');
                    opener.setAttribute('aria-owns', panel.id);

                    _append(select.children, false);

                    // Injects the container in the original DOM position of the select
                    container.appendChild(opener);
                    select.parentNode.replaceChild(container, select);
                    container.appendChild(select);
                    container.appendChild(panel);

                    // ARIA labelledby - label
                    if (document.querySelector('label[for="' + select.id + '"]')) {
                        currLabel = document.querySelector('label[for="' + select.id + '"]');
                    } else if (container.parentNode.tagName.toUpperCase() === 'LABEL') {
                        currLabel = container.parentNode;
                    }
                    if (typeof currLabel !== 'undefined') {
                        currLabel.setAttribute('id', containerClass + '-' + uId + '-label');
                        opener.setAttribute('aria-labelledby', containerClass + '-' + uId + '-label');
                    }

                    // Event Init
                    if (select.disabled) {
                        container.classList.add(builderParams.isDisabledClass);
                    } else {
                        opener.setAttribute('tabindex', '0');
                        select.setAttribute('tabindex', '-1');
                        addEvents();
                    }

                    // Stores the plugin public exposed methods and properties, directly in the container HTMLElement
                    container.customSelect = {
                        get pluginOptions() {
                            return builderParams;
                        },
                        get open() {
                            return isOpen;
                        },
                        set open(bool) {
                            open(bool);
                        },
                        get disabled() {
                            return select.disabled;
                        },
                        set disabled(bool) {
                            disabled(bool);
                        },
                        get value() {
                            return select.value;
                        },
                        set value(val) {
                            setValue(val);
                        },
                        append: function append(node, target) {
                            return _append(node, true, target);
                        },
                        insertBefore: function insertBefore(node, target) {
                            return _insertBefore(node, target);
                        },
                        remove: remove,
                        empty: empty,
                        destroy: destroy,
                        opener: opener,
                        select: select,
                        panel: panel,
                        container: container
                    };

                    // Stores the plugin directly in the original select
                    select.customSelect = container.customSelect;

                    // Returns the plugin instance, with the public exposed methods and properties
                    return container.customSelect;
                }

                function customSelect(element, customParams) {
                    // Overrides the default options with the ones provided by the user
                    var nodeList = [];
                    var selects = [];

                    return function init() {
                        // The plugin is called on a single HTMLElement
                        if (element && element instanceof HTMLElement && element.tagName.toUpperCase() === 'SELECT') {
                            nodeList.push(element);
                            // The plugin is called on a selector
                        } else if (element && typeof element === 'string') {
                            var elementsList = document.querySelectorAll(element);
                            for (var i = 0, l = elementsList.length; i < l; ++i) {
                                if (elementsList[i] instanceof HTMLElement && elementsList[i].tagName.toUpperCase() === 'SELECT') {
                                    nodeList.push(elementsList[i]);
                                }
                            }
                            // The plugin is called on any HTMLElements list (NodeList, HTMLCollection, Array, etc.)
                        } else if (element && element.length) {
                            for (var _i3 = 0, _l3 = element.length; _i3 < _l3; ++_i3) {
                                if (element[_i3] instanceof HTMLElement && element[_i3].tagName.toUpperCase() === 'SELECT') {
                                    nodeList.push(element[_i3]);
                                }
                            }
                        }

                        // Launches the plugin over every HTMLElement
                        // And stores every plugin instance
                        for (var _i4 = 0, _l4 = nodeList.length; _i4 < _l4; ++_i4) {
                            selects.push(builder(nodeList[_i4], _extends({}, defaultParams, customParams)));
                        }

                        // Returns all plugin instances
                        return selects;
                    }();
                }

                //# sourceMappingURL=index.js.map//# sourceURL=[module]
                //# sourceMappingURL=data:application/json;charset=utf-8;base64

            },
        },
        __webpack_module_cache__ = {};

    function __webpack_require__(g) {
        var I = __webpack_module_cache__[g];
        if (void 0 !== I) return I.exports;
        var n = (__webpack_module_cache__[g] = {
            exports: {}
        });
        return __webpack_modules__[g](n, n.exports, __webpack_require__), n.exports;
    }
    __webpack_require__.g = (function() {
        if ("object" == typeof globalThis) return globalThis;
        try {
            return this || new Function("return this")();
        } catch (g) {
            if ("object" == typeof window) return window;
        }
    })();
    var __webpack_exports__ = __webpack_require__(2015);
})();
